var _path, _path2, _path3, _defs, _clipPath, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _path187;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBosch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2500,
    height: 568,
    viewBox: "0 0 143.122 32.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.752 18.363h-9.245v-4.498h9.245v4.498zm-9.183-4.736a.3.3 0 0 0-.299.3v4.639a.3.3 0 0 0 .299.299h9.385a.3.3 0 0 0 .3-.299v-4.639a.3.3 0 0 0-.3-.3h-9.385zm-4.335 2.619c0-2.354.901-4.243 1.677-5.434l-.01.332v9.957l.01.332c-1.141-1.743-1.677-3.394-1.677-5.187m2.247-6.609l-.323.405a9.988 9.988 0 0 0 0 12.408l.368.461-.055-.587a15.667 15.667 0 0 1-.068-1.475v-9.205c0-.495.022-.992.068-1.476l.055-.587-.045.056zM23.344 21.33V10.938l-.009-.327c1.089 1.775 1.691 3.772 1.691 5.636 0 2.355-.896 4.125-1.691 5.414l.009-.331m-.339-11.678l.025.268.023.248c.045.481.067.978.067 1.476v9.205c0 .497-.022.994-.067 1.475l-.056.587.368-.461c1.394-1.749 2.162-3.953 2.162-6.204s-.769-4.455-2.162-6.204l-.367-.462.007.072zm-2.051 2.108a.3.3 0 0 0 .3-.299V6.614a.358.358 0 0 1 .542-.306c3.505 2.128 5.599 5.843 5.599 9.938 0 4.095-2.093 7.81-5.597 9.938a.36.36 0 0 1-.544-.306v-4.846a.3.3 0 0 0-.3-.299h-9.385a.3.3 0 0 0-.299.299v4.846a.36.36 0 0 1-.358.359.36.36 0 0 1-.185-.053c-3.505-2.128-5.599-5.843-5.599-9.938 0-4.095 2.094-7.81 5.598-9.937a.359.359 0 0 1 .544.305v4.847a.3.3 0 0 0 .299.299h9.385zm-.202-5.146v4.645h-9.244V6.614c0-.369-.062-.86-.596-.86a.86.86 0 0 0-.446.126c-3.655 2.219-5.838 6.094-5.838 10.366 0 4.165 2.128 7.845 5.838 10.097.136.082.29.126.446.126.446 0 .596-.406.596-.592V20.97h9.244v4.907c0 .535.491.596.86.596a.57.57 0 0 0 .308-.086c3.523-2.104 5.712-5.99 5.712-10.141 0-4.242-2.188-8.31-5.573-10.366a.862.862 0 0 0-1.307.734M6.619 25.757c-2.63-2.56-4.078-5.938-4.078-9.511 0-7.566 6.155-13.721 13.722-13.721 3.572 0 6.949 1.448 9.511 4.078 2.544 2.613 3.945 6.038 3.945 9.643 0 7.42-6.036 13.458-13.456 13.458-3.606 0-7.031-1.402-9.644-3.947m-4.315-9.511c0 7.697 6.262 13.959 13.959 13.959 7.695 0 13.957-6.262 13.957-13.959S23.958 2.288 16.263 2.288c-7.698 0-13.959 6.261-13.959 13.958m-1.546 0C.758 7.697 7.713.742 16.263.742c8.549 0 15.504 6.955 15.504 15.504S24.812 31.75 16.263 31.75C7.713 31.75.758 24.795.758 16.246m-.502 0c0 4.253 1.667 8.223 4.694 11.181 3.009 2.94 7.027 4.562 11.312 4.562 8.68 0 15.741-7.062 15.741-15.743 0-4.285-1.62-8.302-4.561-11.313C24.485 1.907 20.515.24 16.263.24 7.437.24.256 7.42.256 16.246"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.853 22.193V18.11a.14.14 0 0 1 .14-.14h3.715c1.83 0 2.879.789 2.879 2.166 0 1.437-.964 2.197-2.788 2.197h-3.806a.14.14 0 0 1-.14-.14m0-8.259v-3.868a.14.14 0 0 1 .14-.14h3.806c1.268 0 2.118.846 2.118 2.105 0 .991-.774 2.043-2.209 2.043h-3.715a.14.14 0 0 1-.14-.14m-4.835-8.057v20.504h10.484c3.052 0 6.345-2.164 6.345-5.662 0-3.323-2.523-4.496-3.608-4.846-.082-.027-.166-.054-.166-.158a.14.14 0 0 1 .094-.132c.114-.039 2.768-.992 2.768-4.135 0-3.489-2.359-5.571-6.313-5.571h-9.604zM71.893 16.114c0-3.666 1.787-6.034 4.553-6.034 2.785 0 4.584 2.368 4.584 6.034 0 3.684-1.799 6.065-4.584 6.065-2.766.001-4.553-2.381-4.553-6.065m-4.867 0c0 6.436 3.785 10.759 9.419 10.759s9.42-4.324 9.42-10.759c0-6.435-3.786-10.759-9.42-10.759s-9.419 4.325-9.419 10.759M88.288 11.755c0 4.047 3.185 5.565 5.856 6.126l.729.153c2.601.547 3.825.966 3.825 2.439 0 1.315-1.181 2.198-2.94 2.198-2.065 0-3.885-.905-5.273-2.608l-3.118 3.058c1.665 1.961 3.86 3.752 8.453 3.752 3.924 0 7.896-2.282 7.896-6.646 0-4.467-3.043-5.475-6.433-6.187l-.731-.154c-1.657-.348-3.276-.807-3.276-2.224 0-1.433 1.339-2.074 2.666-2.074 1.553 0 3.092.691 4.257 1.883l3.036-3.005c-1.306-1.443-3.624-3.112-7.384-3.112-4.525.001-7.563 2.573-7.563 6.401M105.927 15.991c0 6.407 3.898 10.882 9.481 10.882 4.156 0 6.046-1.527 8.019-4.339l-3.991-2.694c-.896 1.445-1.862 2.339-3.785 2.339-2.325 0-4.827-1.937-4.827-6.188 0-3.881 2.352-5.911 4.675-5.911 1.688 0 2.868.709 3.816 2.278l3.962-2.634c-2.029-2.994-4.442-4.339-7.809-4.339-6.591.001-9.541 5.327-9.541 10.606M137.782 5.877v7.505a.14.14 0 0 1-.14.14h-6.302a.141.141 0 0 1-.14-.14V5.877h-5.169v20.504h5.169v-8.056a.14.14 0 0 1 .14-.14h6.302a.14.14 0 0 1 .14.14v8.056h5.2V5.877h-5.2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.141 10.816l-.028-.951.394.64c1.11 1.808 1.721 3.846 1.721 5.741 0 2.424-.92 4.223-1.721 5.519l-.394.636.031-1.073v-10.39l.006.049-.009-.171m-11.833 7.547v-4.699h9.646v4.9h-9.646v-.201zm-2.564 3.179c-1.166-1.78-1.71-3.463-1.71-5.296 0-2.411.93-4.345 1.71-5.543l.389-.598-.031 1.045.001 9.951.009.326.021.709-.389-.594zM20.953 6.614v4.845h-9.646V6.614c0-.608-.204-.659-.396-.659a.66.66 0 0 0-.342.096c-3.596 2.183-5.741 5.994-5.741 10.195 0 4.093 2.093 7.711 5.74 9.926a.675.675 0 0 0 .343.096c.365 0 .396-.387.396-.391V20.77h9.646v5.108c0 .191.051.396.659.396a.37.37 0 0 0 .205-.059c3.463-2.068 5.614-5.888 5.614-9.969 0-4.173-2.15-8.174-5.478-10.195a.66.66 0 0 0-1 .563M6.479 25.901c-2.668-2.599-4.138-6.028-4.138-9.655 0-7.676 6.245-13.921 13.922-13.921 3.627 0 7.055 1.469 9.654 4.138 2.581 2.651 4.003 6.126 4.003 9.783 0 7.531-6.127 13.657-13.657 13.657-3.659 0-7.132-1.42-9.784-4.002M.457 16.246c0 4.198 1.645 8.118 4.633 11.038 2.972 2.904 6.939 4.504 11.173 4.504 8.569 0 15.541-6.971 15.541-15.542 0-4.232-1.6-8.2-4.504-11.172C24.38 2.086 20.461.441 16.263.441 7.547.441.457 7.531.457 16.246",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.736 16.246C.736 7.685 7.701.721 16.262.721c8.56 0 15.524 6.964 15.524 15.525s-6.965 15.526-15.524 15.526C7.701 31.772.736 24.807.736 16.246m-.459 0c0 8.814 7.17 15.721 15.985 15.721 8.522 0 15.72-6.916 15.72-15.721 0-8.815-6.906-15.984-15.72-15.984C7.447.262.277 7.431.277 16.246"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.263.601C7.734.601.6 7.719.6 16.247",
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.913
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6c6d6f",
    strokeWidth: 0.571,
    d: "M1.164 22.273l1.088-.493"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6b6c6e",
    strokeWidth: 0.571,
    d: "M1.276 22.543l1.079-.511"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6a6b6d",
    strokeWidth: 0.571,
    d: "M1.394 22.812l1.07-.53"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#696a6c",
    strokeWidth: 0.571,
    d: "M1.518 23.079l1.06-.547"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#68696b",
    strokeWidth: 0.571,
    d: "M1.646 23.343l1.052-.562"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#67686a",
    strokeWidth: 0.571,
    d: "M1.778 23.604l1.045-.578"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#666769",
    strokeWidth: 0.571,
    d: "M1.916 23.862l1.037-.592"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#656668",
    strokeWidth: 0.571,
    d: "M2.058 24.116l1.029-.605"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#646568",
    strokeWidth: 0.571,
    d: "M2.203 24.368l1.021-.618"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#636466",
    strokeWidth: 0.571,
    d: "M2.352 24.616l1.014-.631"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#626365",
    strokeWidth: 0.571,
    d: "M2.504 24.862l1.007-.643"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#616264",
    strokeWidth: 0.571,
    d: "M2.658 25.102l1-.652"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#222223",
    strokeWidth: 0.571,
    d: "M10.933 31.616l.392-1.127"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#212122",
    strokeWidth: 0.571,
    d: "M11.39 31.766l.354-1.141"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 0.571,
    d: "M11.854 31.903l.318-1.151"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#1f1f20",
    strokeWidth: 0.571,
    d: "M12.325 32.025l.282-1.16"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#1e1e1e",
    strokeWidth: 0.571,
    d: "M12.803 32.133l.246-1.17"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#1c1c1d",
    strokeWidth: 0.571,
    d: "M13.286 32.227l.211-1.176"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#1b1b1c",
    strokeWidth: 0.571,
    d: "M13.774 32.307l.175-1.182"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#1a191a",
    strokeWidth: 0.571,
    d: "M14.267 32.373l.14-1.187"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#181818",
    strokeWidth: 0.571,
    d: "M14.763 32.424l.104-1.189"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#171718",
    strokeWidth: 0.571,
    d: "M15.261 32.46l.07-1.192"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#161516",
    strokeWidth: 0.571,
    d: "M15.761 32.483l.035-1.193"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 0.571,
    d: "M16.263 32.491v-1.196"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.571,
    d: "M16.264.004l-.003 1.194"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#76777a",
    strokeWidth: 0.571,
    d: "M16.573.007l-.028 1.194"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#757779",
    strokeWidth: 0.571,
    d: "M16.883.017l-.052 1.192"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#757679",
    strokeWidth: 0.571,
    d: "M17.191.032l-.075 1.193"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#747678",
    strokeWidth: 0.571,
    d: "M17.499.054l-.098 1.19"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#747578",
    strokeWidth: 0.571,
    d: "M17.806.082l-.12 1.188"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#737577",
    strokeWidth: 0.571,
    d: "M18.11.115l-.141 1.186"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#727477",
    strokeWidth: 0.571,
    d: "M18.414.154l-.163 1.183"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#727476",
    strokeWidth: 0.571,
    d: "M18.714.198l-.184 1.18"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#727376",
    strokeWidth: 0.571,
    d: "M19.013.247l-.205 1.177"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#717375",
    strokeWidth: 0.571,
    d: "M19.308.301l-.225 1.173"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6.359l-.245 1.169M19.6.359l-.245 1.169",
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#717275",
    strokeWidth: 0.571
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#707274",
    strokeWidth: 0.571,
    d: "M19.888.422l-.263 1.165"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#707174",
    strokeWidth: 0.571,
    d: "M20.176.491l-.28 1.161"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6f7173",
    strokeWidth: 0.571,
    d: "M20.463.564l-.297 1.158"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6f7073",
    strokeWidth: 0.571,
    d: "M20.749.644l-.313 1.151"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6e7072",
    strokeWidth: 0.571,
    d: "M21.034.727l-.331 1.148"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6e6f72",
    strokeWidth: 0.571,
    d: "M21.316.816l-.346 1.142"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6d6f71",
    strokeWidth: 0.571,
    d: "M21.597.91l-.366 1.137"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6d6e71",
    strokeWidth: 0.571,
    d: "M21.875 1.008l-.382 1.131"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6c6e70",
    strokeWidth: 0.571,
    d: "M22.149 1.111l-.4 1.125"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6c6d70",
    strokeWidth: 0.571,
    d: "M22.421 1.219l-.418 1.119"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M22.252 2.443l.438-1.111m-.001 0l-.438 1.111",
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6c6d6f",
    strokeWidth: 0.571
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6a6c6e",
    strokeWidth: 0.571,
    d: "M22.501 2.557l.46-1.102"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#696a6d",
    strokeWidth: 0.571,
    d: "M22.762 2.681l.481-1.092"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#68696b",
    strokeWidth: 0.571,
    d: "M23.031 2.816l.505-1.082"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#66676a",
    strokeWidth: 0.571,
    d: "M23.311 2.962l.528-1.07"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#656669",
    strokeWidth: 0.571,
    d: "M23.597 3.12l.55-1.059"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#636567",
    strokeWidth: 0.571,
    d: "M23.889 3.289l.575-1.046"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#626366",
    strokeWidth: 0.571,
    d: "M24.187 3.469l.599-1.033"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#616264",
    strokeWidth: 0.571,
    d: "M24.487 3.66l.625-1.018"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#5f6163",
    strokeWidth: 0.571,
    d: "M24.791 3.863l.649-1.002"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#5e5f61",
    strokeWidth: 0.571,
    d: "M25.096 4.078l.676-.984"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#5d5e60",
    strokeWidth: 0.571,
    d: "M25.401 4.305l.703-.965"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#5b5c5e",
    strokeWidth: 0.571,
    d: "M25.706 4.543l.731-.945"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#5a5b5d",
    strokeWidth: 0.571,
    d: "M26.008 4.793l.759-.922"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#58595b",
    strokeWidth: 0.571,
    d: "M26.308 5.056l.787-.898"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#57575a",
    strokeWidth: 0.571,
    d: "M26.603 5.33l.815-.872"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M26.892 5.617l.844-.845m-.844.845l.845-.845",
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#555658",
    strokeWidth: 0.571
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#545456",
    strokeWidth: 0.571,
    d: "M27.198 5.933l.869-.819"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#535355",
    strokeWidth: 0.571,
    d: "M27.496 6.258l.893-.793"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#515153",
    strokeWidth: 0.571,
    d: "M27.785 6.593l.915-.767"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#505052",
    strokeWidth: 0.571,
    d: "M28.065 6.938l.938-.739"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#4e4f50",
    strokeWidth: 0.571,
    d: "M28.336 7.292l.959-.712"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#4d4d4f",
    strokeWidth: 0.571,
    d: "M28.597 7.654l.978-.684"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#4b4b4d",
    strokeWidth: 0.571,
    d: "M28.848 8.024l.998-.655"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#49494b",
    strokeWidth: 0.571,
    d: "M29.088 8.403l1.016-.626"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#48484a",
    strokeWidth: 0.571,
    d: "M29.318 8.79l1.036-.597"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#464648",
    strokeWidth: 0.571,
    d: "M29.537 9.184l1.052-.565"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#454546",
    strokeWidth: 0.571,
    d: "M29.745 9.584l1.068-.533"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#434345",
    strokeWidth: 0.571,
    d: "M29.942 9.993l1.082-.504"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#424143",
    strokeWidth: 0.571,
    d: "M30.127 10.407l1.098-.471"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#403f41",
    strokeWidth: 0.571,
    d: "M30.3 10.828l1.111-.438"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#3d3d3f",
    strokeWidth: 0.571,
    d: "M30.46 11.254l1.124-.404"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#3b3a3c",
    strokeWidth: 0.571,
    d: "M30.608 11.686l1.135-.37"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#373738",
    strokeWidth: 0.571,
    d: "M30.744 12.124l1.146-.337"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#343435",
    strokeWidth: 0.571,
    d: "M30.866 12.565l1.156-.299"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#313031",
    strokeWidth: 0.571,
    d: "M30.975 13.013l1.165-.265"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#2d2d2e",
    strokeWidth: 0.571,
    d: "M31.07 13.464l1.172-.228"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#2a292a",
    strokeWidth: 0.571,
    d: "M31.151 13.919l1.179-.191"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#262627",
    strokeWidth: 0.571,
    d: "M31.219 14.378l1.183-.153"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#222122",
    strokeWidth: 0.571,
    d: "M31.271 14.841l1.189-.116"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#1e1e1e",
    strokeWidth: 0.571,
    d: "M31.31 15.307l1.191-.078"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#1a191a",
    strokeWidth: 0.571,
    d: "M31.332 15.775l1.194-.039"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M31.34 16.246h1.194m-1.194 0h1.194",
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 0.571
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#131314",
    strokeWidth: 0.571,
    d: "M31.332 16.72l1.194.038"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#121213",
    strokeWidth: 0.571,
    d: "M31.31 17.193l1.192.075M31.272 17.662l1.19.113"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#121112",
    strokeWidth: 0.571,
    d: "M31.222 18.129l1.184.15"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#111",
    strokeWidth: 0.571,
    d: "M31.155 18.593l1.18.186"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#101010",
    strokeWidth: 0.571,
    d: "M31.076 19.053l1.174.222M30.982 19.51l1.166.257"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#0f0f0f",
    strokeWidth: 0.571,
    d: "M30.875 19.962l1.158.293"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#0e0e0e",
    strokeWidth: 0.571,
    d: "M30.755 20.41l1.149.327"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#0d0c0d",
    strokeWidth: 0.571,
    d: "M30.622 20.853l1.138.362M30.476 21.291l1.127.395"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#0c0b0c",
    strokeWidth: 0.571,
    d: "M30.317 21.722l1.116.429"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#0a0a0b",
    strokeWidth: 0.571,
    d: "M30.146 22.148l1.102.461"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#09090a",
    strokeWidth: 0.571,
    d: "M29.963 22.568l1.089.494"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#080808",
    strokeWidth: 0.571,
    d: "M29.769 22.981l1.072.526M29.562 23.387l1.056.556"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#070707",
    strokeWidth: 0.571,
    d: "M29.345 23.786l1.04.588"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#060606",
    strokeWidth: 0.571,
    d: "M29.116 24.176l1.021.619"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#050505",
    strokeWidth: 0.571,
    d: "M28.877 24.559l1.003.649M28.627 24.932l.982.68"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.571,
    d: "M28.366 25.297l.962.708"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#030303",
    strokeWidth: 0.571,
    d: "M28.096 25.653l.94.737"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#020202",
    strokeWidth: 0.571,
    d: "M27.815 26l.917.766"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#010101",
    strokeWidth: 0.571,
    d: "M27.526 26.336l.893.793M27.228 26.663l.868.82"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M27.761 27.827l-.842-.849m0 0l.842.849",
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.571
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#010101",
    strokeWidth: 0.571,
    d: "M27.419 28.155l-.815-.874M27.066 28.473l-.787-.898"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#020202",
    strokeWidth: 0.571,
    d: "M26.703 28.781l-.758-.923"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#030303",
    strokeWidth: 0.571,
    d: "M26.33 29.079l-.73-.946"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.571,
    d: "M25.946 29.366l-.701-.968"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#050505",
    strokeWidth: 0.571,
    d: "M25.554 29.641l-.672-.988M25.152 29.905l-.641-1.008"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#060606",
    strokeWidth: 0.571,
    d: "M24.742 30.158l-.612-1.027"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#070707",
    strokeWidth: 0.571,
    d: "M24.323 30.399l-.581-1.043"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#080808",
    strokeWidth: 0.571,
    d: "M23.896 30.627l-.549-1.06M23.462 30.844l-.52-1.075"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#09090a",
    strokeWidth: 0.571,
    d: "M23.021 31.049l-.488-1.09"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#0a0a0b",
    strokeWidth: 0.571,
    d: "M22.571 31.241l-.455-1.104"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#0c0b0c",
    strokeWidth: 0.571,
    d: "M22.116 31.42l-.424-1.117"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#0d0c0d",
    strokeWidth: 0.571,
    d: "M21.654 31.586l-.389-1.128M21.187 31.739l-.357-1.14"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#0e0e0e",
    strokeWidth: 0.571,
    d: "M20.714 31.878l-.323-1.149"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#0f0f0f",
    strokeWidth: 0.571,
    d: "M20.235 32.004l-.289-1.158"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#101010",
    strokeWidth: 0.571,
    d: "M19.752 32.117l-.255-1.167M19.265 32.213l-.22-1.171"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#111",
    strokeWidth: 0.571,
    d: "M18.772 32.297l-.184-1.179"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#121112",
    strokeWidth: 0.571,
    d: "M18.277 32.366l-.149-1.185"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#121213",
    strokeWidth: 0.571,
    d: "M17.778 32.42l-.114-1.188M17.276 32.458l-.077-1.192"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#131314",
    strokeWidth: 0.571,
    d: "M16.771 32.483l-.041-1.195"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 0.571,
    d: "M16.265 32.491l-.004-1.196"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#555658",
    strokeWidth: 0.571,
    d: "M4.797 27.715l.84-.849"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#535456",
    strokeWidth: 0.571,
    d: "M5.12 28.03l.817-.871"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#515254",
    strokeWidth: 0.571,
    d: "M5.452 28.336l.794-.892"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#4f4f51",
    strokeWidth: 0.571,
    d: "M5.794 28.635l.77-.912"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#4d4d4f",
    strokeWidth: 0.571,
    d: "M6.145 28.926l.746-.931"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#4b4b4d",
    strokeWidth: 0.571,
    d: "M6.503 29.208l.723-.953"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#48484a",
    strokeWidth: 0.571,
    d: "M6.871 29.481l.696-.971"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#464648",
    strokeWidth: 0.571,
    d: "M7.246 29.744l.67-.988"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#444446",
    strokeWidth: 0.571,
    d: "M7.63 29.997l.642-1.006"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#424243",
    strokeWidth: 0.571,
    d: "M8.02 30.241l.615-1.025"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#3f3f41",
    strokeWidth: 0.571,
    d: "M8.417 30.473l.586-1.041"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#3b3b3c",
    strokeWidth: 0.571,
    d: "M8.821 30.694l.557-1.057"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#373638",
    strokeWidth: 0.571,
    d: "M9.232 30.903l.527-1.072"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#323233",
    strokeWidth: 0.571,
    d: "M9.649 31.101l.495-1.087"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#2d2d2e",
    strokeWidth: 0.571,
    d: "M10.071 31.286l.462-1.102"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#282829",
    strokeWidth: 0.571,
    d: "M10.5 31.458l.428-1.116"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#222223",
    strokeWidth: 0.571,
    d: "M10.933 31.616l.392-1.128"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#616264",
    strokeWidth: 0.571,
    d: "M2.658 25.102l1-.652"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#606163",
    strokeWidth: 0.571,
    d: "M2.829 25.358l.985-.676"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#5f6062",
    strokeWidth: 0.571,
    d: "M3.006 25.61l.971-.695"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#5e5f61",
    strokeWidth: 0.571,
    d: "M3.188 25.859l.956-.716"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#5d5e60",
    strokeWidth: 0.571,
    d: "M3.375 26.104l.941-.733"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#5c5d5f",
    strokeWidth: 0.571,
    d: "M3.566 26.348l.928-.752"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#5b5c5e",
    strokeWidth: 0.571,
    d: "M3.763 26.586l.913-.769"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#5a5b5d",
    strokeWidth: 0.571,
    d: "M3.963 26.821l.898-.786"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#58595c",
    strokeWidth: 0.571,
    d: "M4.167 27.051l.884-.802"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#57585a",
    strokeWidth: 0.571,
    d: "M4.374 27.278l.87-.819"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#56575a",
    strokeWidth: 0.571,
    d: "M4.584 27.499l.855-.834"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#555658",
    strokeWidth: 0.571,
    d: "M4.798 27.715l.84-.848"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#717275",
    strokeWidth: 0.571,
    d: "M.272 19.346l1.173-.226"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#707274",
    strokeWidth: 0.571,
    d: "M.33 19.622l1.166-.259"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#707174",
    strokeWidth: 0.571,
    d: "M.393 19.896l1.159-.288"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6f7173",
    strokeWidth: 0.571,
    d: "M.462 20.17l1.15-.316"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6f7073",
    strokeWidth: 0.571,
    d: "M.535 20.442l1.144-.343"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6e7072",
    strokeWidth: 0.571,
    d: "M.614 20.712l1.136-.367"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6e6f72",
    strokeWidth: 0.571,
    d: "M.697 20.979l1.128-.392"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6d6f71",
    strokeWidth: 0.571,
    d: "M.784 21.245l1.12-.414"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6d6e71",
    strokeWidth: 0.571,
    d: "M.875 21.506l1.112-.435"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6c6e70",
    strokeWidth: 0.571,
    d: "M.969 21.766l1.103-.455"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6c6d70",
    strokeWidth: 0.571,
    d: "M1.065 22.021l1.096-.474"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#6c6d6f",
    strokeWidth: 0.571,
    d: "M1.164 22.272l1.088-.492"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.571,
    d: "M.002 16.247l1.193-.001"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#76777a",
    strokeWidth: 0.571,
    d: "M.004 16.53l1.193-.017"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#757779",
    strokeWidth: 0.571,
    d: "M.01 16.814l1.194-.035"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#757679",
    strokeWidth: 0.571,
    d: "M.02 17.099l1.193-.052"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#747678",
    strokeWidth: 0.571,
    d: "M.034 17.383l1.194-.071"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#747578",
    strokeWidth: 0.571,
    d: "M.054 17.667l1.19-.09"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#737577",
    strokeWidth: 0.571,
    d: "M.077 17.952l1.189-.111"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#727477",
    strokeWidth: 0.571,
    d: "M.105 18.234l1.188-.131"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#727476",
    strokeWidth: 0.571,
    d: "M.14 18.515l1.183-.154"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#727376",
    strokeWidth: 0.571,
    d: "M.179 18.795l1.18-.177"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#717375",
    strokeWidth: 0.571,
    d: "M.223 19.072l1.176-.201"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "none",
    stroke: "#717275",
    strokeWidth: 0.571,
    d: "M.272 19.347l1.174-.227"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M2.52 16.246c0-7.511 6.114-13.742 13.743-13.742 7.431 0 13.478 6.311 13.478 13.742 0 7.432-6.047 13.479-13.478 13.479-7.434 0-13.743-6.047-13.743-13.479m-.196 0c0 7.685 6.252 13.938 13.938 13.938 7.685 0 13.937-6.253 13.937-13.938 0-7.684-6.252-13.936-13.937-13.936-7.686 0-13.938 6.252-13.938 13.936"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 0.571,
    d: "M16.263 3.041V1.847"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#161516",
    strokeWidth: 0.571,
    d: "M16.774 3.05l.043-1.193"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#171718",
    strokeWidth: 0.571,
    d: "M17.279 3.079l.087-1.191"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#181818",
    strokeWidth: 0.571,
    d: "M17.775 3.126l.132-1.187"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#1a191a",
    strokeWidth: 0.571,
    d: "M18.266 3.191l.173-1.182"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#1b1b1c",
    strokeWidth: 0.571,
    d: "M18.748 3.274l.219-1.174"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#1c1c1d",
    strokeWidth: 0.571,
    d: "M19.225 3.375l.26-1.165"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#1e1e1e",
    strokeWidth: 0.571,
    d: "M19.694 3.494l.303-1.155"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#1f1f20",
    strokeWidth: 0.571,
    d: "M20.158 3.629l.345-1.143"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 0.571,
    d: "M20.616 3.782l.386-1.131"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#212122",
    strokeWidth: 0.571,
    d: "M21.07 3.951l.424-1.116"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#222223",
    strokeWidth: 0.571,
    d: "M21.519 4.137l.46-1.102"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#0a0a0b",
    strokeWidth: 0.571,
    d: "M10.915 4.162l-.484-1.093"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#0c0b0c",
    strokeWidth: 0.571,
    d: "M11.37 3.97l-.444-1.109"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#0d0c0d",
    strokeWidth: 0.571,
    d: "M11.829 3.795l-.401-1.125"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#0e0e0e",
    strokeWidth: 0.571,
    d: "M12.295 3.639L11.936 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#0f0f0f",
    strokeWidth: 0.571,
    d: "M12.767 3.5l-.316-1.152M13.244 3.379l-.269-1.163"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#111",
    strokeWidth: 0.571,
    d: "M13.729 3.277l-.225-1.173M14.221 3.193l-.18-1.181"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#121112",
    strokeWidth: 0.571,
    d: "M14.719 3.126l-.134-1.187"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#121213",
    strokeWidth: 0.571,
    d: "M15.226 3.079l-.09-1.191"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#131314",
    strokeWidth: 0.571,
    d: "M15.739 3.051l-.044-1.194"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 0.571,
    d: "M16.263 3.041V1.847"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.571,
    d: "M6.928 6.892l-.845-.846"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#010101",
    strokeWidth: 0.571,
    d: "M7.246 6.583l-.814-.873"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#020202",
    strokeWidth: 0.571,
    d: "M7.574 6.288l-.786-.9"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#030303",
    strokeWidth: 0.571,
    d: "M7.91 6.004l-.755-.926"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.571,
    d: "M8.254 5.732l-.723-.951"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#050505",
    strokeWidth: 0.571,
    d: "M8.607 5.472l-.691-.974M8.969 5.225l-.657-.998"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#060606",
    strokeWidth: 0.571,
    d: "M9.34 4.989L8.717 3.97"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#070707",
    strokeWidth: 0.571,
    d: "M9.719 4.765l-.588-1.04"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#080808",
    strokeWidth: 0.571,
    d: "M10.108 4.552l-.553-1.059"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#09090a",
    strokeWidth: 0.571,
    d: "M10.506 4.352l-.517-1.078"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#0a0a0b",
    strokeWidth: 0.571,
    d: "M10.914 4.162l-.482-1.093"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.571,
    d: "M6.928 6.892l-.845-.846"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#010101",
    strokeWidth: 0.571,
    d: "M6.62 7.208l-.87-.817"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#020202",
    strokeWidth: 0.571,
    d: "M6.324 7.533l-.896-.79"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#030303",
    strokeWidth: 0.571,
    d: "M6.04 7.866l-.922-.76"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.571,
    d: "M5.768 8.207l-.946-.729"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#050505",
    strokeWidth: 0.571,
    d: "M5.508 8.557l-.971-.698M5.259 8.915l-.993-.665"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#060606",
    strokeWidth: 0.571,
    d: "M5.022 9.281l-1.015-.63"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#070707",
    strokeWidth: 0.571,
    d: "M4.797 9.657l-1.035-.596"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#080808",
    strokeWidth: 0.571,
    d: "M4.584 10.042l-1.056-.561"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#09090a",
    strokeWidth: 0.571,
    d: "M4.382 10.436L3.31 9.911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.104 10.35l1.089.49m-.001-.001l-1.09-.489",
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#0a0a0b",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#0c0b0c",
    strokeWidth: 0.571,
    d: "M2.89 10.85l1.106.447"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#0d0c0d",
    strokeWidth: 0.571,
    d: "M2.695 11.356l1.123.406"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#0e0e0e",
    strokeWidth: 0.571,
    d: "M2.52 11.871l1.138.361"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#0f0f0f",
    strokeWidth: 0.571,
    d: "M2.364 12.392l1.153.316M2.229 12.921l1.163.271"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#111",
    strokeWidth: 0.571,
    d: "M2.113 13.457l1.173.225M2.019 14.001l1.18.178"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#121112",
    strokeWidth: 0.571,
    d: "M1.944 14.552l1.188.131"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#121213",
    strokeWidth: 0.571,
    d: "M1.892 15.11l1.19.085"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#131314",
    strokeWidth: 0.571,
    d: "M1.859 15.676l1.195.039"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 0.571,
    d: "M1.849 16.25l1.194-.008"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#6c6d6f",
    strokeWidth: 0.571,
    d: "M10.834 29.565l.452-1.106"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#6c6e70",
    strokeWidth: 0.571,
    d: "M11.298 29.746l.416-1.121"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#6d6f71",
    strokeWidth: 0.571,
    d: "M11.768 29.911l.378-1.133"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#6e7072",
    strokeWidth: 0.571,
    d: "M12.242 30.061l.339-1.145"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#6f7173",
    strokeWidth: 0.571,
    d: "M12.723 30.194l.298-1.156"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#707274",
    strokeWidth: 0.571,
    d: "M13.209 30.31l.257-1.166"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#717375",
    strokeWidth: 0.571,
    d: "M13.701 30.409l.215-1.174"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#727476",
    strokeWidth: 0.571,
    d: "M14.2 30.491l.172-1.181"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#737577",
    strokeWidth: 0.571,
    d: "M14.705 30.555l.129-1.187"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#747678",
    strokeWidth: 0.571,
    d: "M15.218 30.602l.086-1.191"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#757779",
    strokeWidth: 0.571,
    d: "M15.736 30.63l.043-1.194"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.571,
    d: "M16.263 30.639v-1.193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.061 16.246c0 7.701-6.098 13.796-13.799 13.796",
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.913
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#555658",
    strokeWidth: 0.571,
    d: "M6.001 26.322l.841-.848"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#57585a",
    strokeWidth: 0.571,
    d: "M6.383 26.697l.809-.877"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#5a5b5d",
    strokeWidth: 0.571,
    d: "M6.775 27.055l.78-.904"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#5c5d5f",
    strokeWidth: 0.571,
    d: "M7.18 27.399l.746-.933"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#5e5f61",
    strokeWidth: 0.571,
    d: "M7.596 27.725l.713-.959"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#606163",
    strokeWidth: 0.571,
    d: "M8.023 28.037l.677-.984"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#626365",
    strokeWidth: 0.571,
    d: "M8.463 28.332l.641-1.007"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#646568",
    strokeWidth: 0.571,
    d: "M8.913 28.611l.605-1.03"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#666769",
    strokeWidth: 0.571,
    d: "M9.376 28.874l.567-1.051"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#68696b",
    strokeWidth: 0.571,
    d: "M9.851 29.12l.528-1.071"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#6a6b6d",
    strokeWidth: 0.571,
    d: "M10.337 29.35l.489-1.088"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#6c6d6f",
    strokeWidth: 0.571,
    d: "M10.834 29.565l.452-1.107"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#222223",
    strokeWidth: 0.571,
    d: "M2.927 21.606l1.103-.457"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#2a2a2b",
    strokeWidth: 0.571,
    d: "M3.131 22.088l1.087-.494"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#323133",
    strokeWidth: 0.571,
    d: "M3.35 22.56l1.068-.532"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#383839",
    strokeWidth: 0.571,
    d: "M3.583 23.021l1.05-.571"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#3f3e40",
    strokeWidth: 0.571,
    d: "M3.832 23.471l1.028-.607"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#424244",
    strokeWidth: 0.571,
    d: "M4.096 23.91l1.006-.644"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#464648",
    strokeWidth: 0.571,
    d: "M4.375 24.338l.981-.68"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#49494b",
    strokeWidth: 0.571,
    d: "M4.67 24.756l.954-.716"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#4c4d4f",
    strokeWidth: 0.571,
    d: "M4.979 25.164l.928-.751"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#4f5052",
    strokeWidth: 0.571,
    d: "M5.305 25.561l.899-.786"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#525355",
    strokeWidth: 0.571,
    d: "M5.646 25.947l.87-.819"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#555658",
    strokeWidth: 0.571,
    d: "M6.001 26.322l.841-.849"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 0.571,
    d: "M1.849 16.25l1.194-.007"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#161516",
    strokeWidth: 0.571,
    d: "M1.858 16.77l1.194-.053"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#171718",
    strokeWidth: 0.571,
    d: "M1.888 17.283l1.19-.097"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#181818",
    strokeWidth: 0.571,
    d: "M1.937 17.79l1.185-.144"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#1a191a",
    strokeWidth: 0.571,
    d: "M2.003 18.288l1.179-.188"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#1b1b1c",
    strokeWidth: 0.571,
    d: "M2.087 18.78l1.172-.231"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#1c1c1d",
    strokeWidth: 0.571,
    d: "M2.188 19.266l1.163-.273"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#1e1e1e",
    strokeWidth: 0.571,
    d: "M2.306 19.745l1.152-.313"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#1f1f20",
    strokeWidth: 0.571,
    d: "M2.438 20.219l1.142-.352"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 0.571,
    d: "M2.587 20.687l1.129-.389"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#212122",
    strokeWidth: 0.571,
    d: "M2.75 21.148l1.117-.423"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.519 4.137l.461-1.101M2.927 21.606l1.103-.457",
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#222223",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#2a2a2b",
    strokeWidth: 0.571,
    d: "M21.936 4.327l.496-1.088"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#323133",
    strokeWidth: 0.571,
    d: "M22.343 4.526l.531-1.069"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#383839",
    strokeWidth: 0.571,
    d: "M22.741 4.738l.566-1.052"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#3f3e40",
    strokeWidth: 0.571,
    d: "M23.129 4.961l.601-1.032"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#424244",
    strokeWidth: 0.571,
    d: "M23.508 5.196l.638-1.01"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#464648",
    strokeWidth: 0.571,
    d: "M23.878 5.443l.672-.987"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#49494b",
    strokeWidth: 0.571,
    d: "M24.238 5.702l.707-.964"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#4c4d4f",
    strokeWidth: 0.571,
    d: "M24.59 5.973l.741-.937"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#4f5052",
    strokeWidth: 0.571,
    d: "M24.932 6.257l.774-.909"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#525355",
    strokeWidth: 0.571,
    d: "M25.265 6.554l.807-.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.588 6.865l.839-.849m-.839.849l.839-.849",
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#555658",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#57585a",
    strokeWidth: 0.571,
    d: "M25.925 7.212l.87-.816"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#5a5b5d",
    strokeWidth: 0.571,
    d: "M26.245 7.572l.901-.783"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#5c5d5f",
    strokeWidth: 0.571,
    d: "M26.55 7.943l.931-.748"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#5e5f61",
    strokeWidth: 0.571,
    d: "M26.84 8.324l.958-.713"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#606163",
    strokeWidth: 0.571,
    d: "M27.116 8.717l.983-.678"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#626365",
    strokeWidth: 0.571,
    d: "M27.377 9.121l1.007-.642"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#646568",
    strokeWidth: 0.571,
    d: "M27.624 9.535l1.028-.607"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#666769",
    strokeWidth: 0.571,
    d: "M27.857 9.96l1.048-.571"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#68696b",
    strokeWidth: 0.571,
    d: "M28.078 10.396l1.066-.538"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#6a6b6d",
    strokeWidth: 0.571,
    d: "M28.285 10.843l1.082-.504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.576 10.829l-1.097.471m0-.001l1.097-.471",
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#6c6d6f",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#6c6e70",
    strokeWidth: 0.571,
    d: "M29.758 11.291l-1.112.435"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#6d6f71",
    strokeWidth: 0.571,
    d: "M29.923 11.759l-1.127.396"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#6e7072",
    strokeWidth: 0.571,
    d: "M30.073 12.233l-1.14.356"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#6f7173",
    strokeWidth: 0.571,
    d: "M30.207 12.712l-1.152.314"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#707274",
    strokeWidth: 0.571,
    d: "M30.324 13.197l-1.163.271"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#717375",
    strokeWidth: 0.571,
    d: "M30.425 13.688l-1.173.228"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#727476",
    strokeWidth: 0.571,
    d: "M30.507 14.187l-1.18.181"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#737577",
    strokeWidth: 0.571,
    d: "M30.572 14.691l-1.186.137"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#747678",
    strokeWidth: 0.571,
    d: "M30.619 15.202l-1.19.091"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#757779",
    strokeWidth: 0.571,
    d: "M30.647 15.72l-1.193.046"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.571,
    d: "M30.657 16.246h-1.194"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M9.33 9.861l-.155.195a9.964 9.964 0 0 0 0 12.382l.322.405-.562-1.332c-.932-1.404-1.723-3.115-1.723-5.265 0-2.109.727-4.005 1.723-5.512l.562-1.084-.167.211z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.241 9.041c-.283.283-.58.605-.871.936a7.968 7.968 0 0 0-.328.406 9.442 9.442 0 0 0-.915 1.5",
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.141
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.571,
    d: "M7.591 11.621l1.072.524"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#020202",
    strokeWidth: 0.571,
    d: "M7.406 12.02l1.096.477"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.571,
    d: "M7.241 12.423l1.113.431"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#050505",
    strokeWidth: 0.571,
    d: "M7.093 12.832l1.132.38"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#070707",
    strokeWidth: 0.571,
    d: "M6.964 13.244l1.146.332"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#09090a",
    strokeWidth: 0.571,
    d: "M6.852 13.661l1.16.283"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#0c0b0c",
    strokeWidth: 0.571,
    d: "M6.758 14.082l1.171.234"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#0e0e0e",
    strokeWidth: 0.571,
    d: "M6.682 14.507l1.179.185"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#0f0f0f",
    strokeWidth: 0.571,
    d: "M6.622 14.937l1.188.136"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#111",
    strokeWidth: 0.571,
    d: "M6.581 15.37l1.19.088"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#121213",
    strokeWidth: 0.571,
    d: "M6.556 15.808l1.194.042"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 0.571,
    d: "M6.548 16.248l1.194-.004"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#555658",
    strokeWidth: 0.571,
    d: "M9.746 23.643l.764-.917M9.508 23.435l.832-.856"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#545557",
    strokeWidth: 0.571,
    d: "M9.294 23.208l.894-.789"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#545456",
    strokeWidth: 0.571,
    d: "M9.077 22.946l.921-.758"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#535456",
    strokeWidth: 0.571,
    d: "M8.85 22.656l.926-.752"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#535356",
    strokeWidth: 0.571,
    d: "M8.661 22.403l.94-.737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.481 22.148l.948-.725m-.948.725l.948-.725",
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#535355",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#4d4e50",
    strokeWidth: 0.571,
    d: "M8.247 21.803l.957-.715"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#48484a",
    strokeWidth: 0.571,
    d: "M8.018 21.453l.973-.692"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#424244",
    strokeWidth: 0.571,
    d: "M7.796 21.092l.998-.655"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#3b3a3c",
    strokeWidth: 0.571,
    d: "M7.587 20.718l1.029-.606"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#2f2f30",
    strokeWidth: 0.571,
    d: "M7.395 20.325l1.062-.544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.223 19.91l1.098-.47m-1.098.47l1.098-.47",
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#222223",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#212122",
    strokeWidth: 0.571,
    d: "M7.108 19.588l1.113-.433"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 0.571,
    d: "M7.004 19.265l1.127-.395"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#1f1f20",
    strokeWidth: 0.571,
    d: "M6.91 18.94l1.14-.356"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#1e1e1e",
    strokeWidth: 0.571,
    d: "M6.826 18.613l1.153-.314"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#1c1c1d",
    strokeWidth: 0.571,
    d: "M6.754 18.284l1.162-.272"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#1b1b1c",
    strokeWidth: 0.571,
    d: "M6.691 17.952l1.172-.228"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#1a191a",
    strokeWidth: 0.571,
    d: "M6.64 17.617l1.18-.183"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#181818",
    strokeWidth: 0.571,
    d: "M6.6 17.28l1.186-.139"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#171718",
    strokeWidth: 0.571,
    d: "M6.571 16.939l1.19-.094"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#161516",
    strokeWidth: 0.571,
    d: "M6.554 16.595l1.193-.049"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 0.571,
    d: "M6.548 16.249l1.194-.005"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M23.311 10.528c.939 1.504 1.736 3.521 1.736 5.718 0 2.226-.797 3.99-1.736 5.495l-.284 1.102.323-.405a9.97 9.97 0 0 0 0-12.382l-.324-.406.285.878z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.497 10.345c-.074-.101-.329-.455-.478-.655-.01-.014-.251-.436-.427-.668",
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#555658",
    strokeWidth: 1.141
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.406 16.247c-.105 1.303-.075 1.741-.484 2.963-.263.784-.795 1.96-1.264 2.644-.135.197-.34.429-.484.621-.327.436-.554.819-.791 1.033",
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 1.141
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#555658",
    strokeWidth: 0.571,
    d: "M23.038 10.726l.918-.763"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#57575a",
    strokeWidth: 0.571,
    d: "M23.179 10.939l.97-.694"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#58595b",
    strokeWidth: 0.571,
    d: "M23.31 11.166l1.008-.638"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#5a5b5d",
    strokeWidth: 0.571,
    d: "M23.435 11.406l1.034-.597"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#5b5c5e",
    strokeWidth: 0.571,
    d: "M23.558 11.661l1.046-.576"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#5d5e60",
    strokeWidth: 0.571,
    d: "M23.683 11.927l1.048-.571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.815 12.204l1.041-.586m-1.041.586l1.041-.586",
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#5e5f61",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#606164",
    strokeWidth: 0.571,
    d: "M23.98 12.559l1.062-.546"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#636466",
    strokeWidth: 0.571,
    d: "M24.132 12.916l1.083-.503"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#656668",
    strokeWidth: 0.571,
    d: "M24.269 13.273l1.102-.456"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#67686b",
    strokeWidth: 0.571,
    d: "M24.392 13.634l1.122-.408"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#696b6d",
    strokeWidth: 0.571,
    d: "M24.499 13.997l1.14-.357"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#6b6d6f",
    strokeWidth: 0.571,
    d: "M24.592 14.362l1.155-.301"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#6d6f71",
    strokeWidth: 0.571,
    d: "M24.669 14.731l1.168-.245"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#707174",
    strokeWidth: 0.571,
    d: "M24.729 15.103l1.179-.186"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#727376",
    strokeWidth: 0.571,
    d: "M24.773 15.479l1.188-.125"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#747578",
    strokeWidth: 0.571,
    d: "M24.8 15.86l1.192-.063"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.571,
    d: "M24.809 16.247h1.194"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M11.486 13.844h9.287v4.54h-9.287v-4.54zm.083-.195a.279.279 0 0 0-.277.279v4.638a.28.28 0 0 0 .277.279h9.385a.28.28 0 0 0 .278-.279v-4.638a.279.279 0 0 0-.278-.279h-9.385z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.396 18.428l.001-4.362c0-.168.076-.291.243-.291l9.2-.002",
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 0.913
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.137 14.375l.087 4.158c0 .11-.074.204-.145.204l-8.97-.059",
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.913
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#252525",
    strokeWidth: 0.571,
    d: "M12.48 18.657l-1.776-.344"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#2a2a2b",
    strokeWidth: 0.571,
    d: "M12.478 18.682l-1.777-.344"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#302f30",
    strokeWidth: 0.571,
    d: "M12.475 18.708l-1.776-.345"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#353436",
    strokeWidth: 0.571,
    d: "M12.49 18.589l-1.808-.047"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#3a393b",
    strokeWidth: 0.571,
    d: "M12.485 18.47l-1.791.253"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#3e3d3f",
    strokeWidth: 0.571,
    d: "M12.45 18.316l-1.703.611"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#414143",
    strokeWidth: 0.571,
    d: "M12.37 18.152l-1.518.983"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#444345",
    strokeWidth: 0.571,
    d: "M12.256 18.009L11 19.312"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#464648",
    strokeWidth: 0.571,
    d: "M12.132 17.91l-.97 1.527"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#48484a",
    strokeWidth: 0.571,
    d: "M12.026 17.851l-.712 1.663"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#4b4b4d",
    strokeWidth: 0.571,
    d: "M11.949 17.821l-.506 1.736"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#4d4d4f",
    strokeWidth: 0.571,
    d: "M11.901 17.807l-.353 1.775"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#4f4f51",
    strokeWidth: 0.571,
    d: "M11.878 17.8l-.246 1.792"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#515254",
    strokeWidth: 0.571,
    d: "M11.875 17.797l-.177 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#545456",
    strokeWidth: 0.571,
    d: "M11.89 17.795l-.138 1.803"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#565658",
    strokeWidth: 0.571,
    d: "M11.919 17.795l-.127 1.805"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#58595b",
    strokeWidth: 0.571,
    d: "M11.962 17.795l-.14 1.803"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#5a5b5d",
    strokeWidth: 0.571,
    d: "M12.07 17.806l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#5c5d5f",
    strokeWidth: 0.571,
    d: "M12.097 17.808l-.3 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#5e5f61",
    strokeWidth: 0.571,
    d: "M12.122 17.81l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#606164",
    strokeWidth: 0.571,
    d: "M12.147 17.812l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#626366",
    strokeWidth: 0.571,
    d: "M12.173 17.814l-.3 1.785"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#646668",
    strokeWidth: 0.571,
    d: "M12.198 17.816l-.3 1.785"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#66686a",
    strokeWidth: 0.571,
    d: "M12.224 17.818l-.299 1.785"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#686a6c",
    strokeWidth: 0.571,
    d: "M12.249 17.82l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#6a6c6e",
    strokeWidth: 0.571,
    d: "M12.274 17.822l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#6c6e70",
    strokeWidth: 0.571,
    d: "M12.3 17.825l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#6e7072",
    strokeWidth: 0.571,
    d: "M12.324 17.827l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#707274",
    strokeWidth: 0.571,
    d: "M12.35 17.829l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#727476",
    strokeWidth: 0.571,
    d: "M12.376 17.831l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#747678",
    strokeWidth: 0.571,
    d: "M12.401 17.833l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.571,
    d: "M12.426 17.835l-.298 1.785"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#2f2f30",
    strokeWidth: 0.571,
    d: "M20.956 13.344l-.323 1.149"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#363537",
    strokeWidth: 0.571,
    d: "M20.975 13.343l-.288 1.152"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#3c3c3e",
    strokeWidth: 0.571,
    d: "M21.008 13.345l-.275 1.149"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#414143",
    strokeWidth: 0.571,
    d: "M21.045 13.349l-.275 1.142"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#454446",
    strokeWidth: 0.571,
    d: "M21.09 13.356l-.299 1.133"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#48484a",
    strokeWidth: 0.571,
    d: "M21.145 13.369l-.349 1.113"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#4b4b4d",
    strokeWidth: 0.571,
    d: "M21.212 13.391l-.43 1.081"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#4e4f50",
    strokeWidth: 0.571,
    d: "M21.292 13.426l-.542 1.027"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#515254",
    strokeWidth: 0.571,
    d: "M21.381 13.481l-.678.938"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#545557",
    strokeWidth: 0.571,
    d: "M21.47 13.556l-.82.816"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#57585a",
    strokeWidth: 0.571,
    d: "M21.546 13.645l-.94.673"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#5a5b5d",
    strokeWidth: 0.571,
    d: "M21.603 13.737l-1.027.532"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#5d5e61",
    strokeWidth: 0.571,
    d: "M21.641 13.822l-1.08.412"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#606163",
    strokeWidth: 0.571,
    d: "M21.665 13.898l-1.111.322"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#636467",
    strokeWidth: 0.571,
    d: "M21.682 13.966l-1.131.258"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#666769",
    strokeWidth: 0.571,
    d: "M21.692 14.028l-1.142.216"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#696a6c",
    strokeWidth: 0.571,
    d: "M21.699 14.087l-1.15.193"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#6b6d6f",
    strokeWidth: 0.571,
    d: "M21.703 14.146l-1.156.184"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#6e6f72",
    strokeWidth: 0.571,
    d: "M21.704 14.18l-1.158.201"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#717275",
    strokeWidth: 0.571,
    d: "M21.704 14.199l-1.157.229"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#737577",
    strokeWidth: 0.571,
    d: "M21.705 14.218l-1.159.258"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.571,
    d: "M21.705 14.236l-1.159.286"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M20.954 11.74a.279.279 0 0 0 .278-.278V6.615a.379.379 0 0 1 .575-.325c3.511 2.133 5.609 5.854 5.609 9.956 0 4.103-2.098 7.825-5.608 9.956a.376.376 0 0 1-.576-.324V21.03a.278.278 0 0 0-.278-.276h-9.385a.278.278 0 0 0-.277.276v4.848a.38.38 0 0 1-.575.326c-3.513-2.132-5.608-5.855-5.608-9.958 0-4.102 2.096-7.823 5.607-9.956a.38.38 0 0 1 .576.325v4.847c0 .153.125.278.277.278h9.385zm-.18-5.125v4.666h-9.288V6.615c0-.462-.111-.838-.575-.838a.837.837 0 0 0-.434.122c-3.649 2.215-5.828 6.083-5.828 10.347 0 4.264 2.178 7.864 5.827 10.08a.853.853 0 0 0 .435.122c.438 0 .575-.396.575-.57v-4.93h9.288v4.93c0 .463.375.576.837.576a.558.558 0 0 0 .297-.084c3.436-2.053 5.702-5.824 5.702-10.124 0-3.866-1.915-8.132-5.562-10.347a.838.838 0 0 0-1.274.716"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.123 24.525a17.693 17.693 0 0 1-2.041 1.692",
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.712
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.267 6.202a.656.656 0 0 0-.343-.129c-.063 0-.25.085-.306.118-.184.112-.334.199-.51.319-3.171 2.164-5.128 5.866-5.128 9.736",
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 1.712
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.406 6.723v4.905m.015 14.05l.004-4.537c0-.098.053-.201.194-.201l9.325.003",
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 1.712
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.069 21.516l.019 3.975m-.007-18.647v4.435c0 .168.03.313-.138.313h-.847l-8.068-.004",
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 1.712
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.571,
    d: "M22.62 26.944l-1.077-1.453"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#0c0b0c",
    strokeWidth: 0.571,
    d: "M22.568 26.981l-1.061-1.465"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#161516",
    strokeWidth: 0.571,
    d: "M22.491 27.035l-1.012-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#1e1e1e",
    strokeWidth: 0.571,
    d: "M22.388 27.098l-.919-1.557"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#252525",
    strokeWidth: 0.571,
    d: "M22.25 27.17l-.757-1.642"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#2c2c2d",
    strokeWidth: 0.571,
    d: "M22.067 27.237l-.516-1.734"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#323133",
    strokeWidth: 0.571,
    d: "M21.922 27.274l-.385-1.768"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#373738",
    strokeWidth: 0.571,
    d: "M21.789 27.297l-.271-1.789"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#3c3c3e",
    strokeWidth: 0.571,
    d: "M21.67 27.311l-.174-1.801"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#414042",
    strokeWidth: 0.571,
    d: "M21.567 27.317l-.095-1.807"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#434345",
    strokeWidth: 0.571,
    d: "M21.483 27.319l-.036-1.809"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#464648",
    strokeWidth: 0.571,
    d: "M21.424 27.319l-.005-1.809"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#49494b",
    strokeWidth: 0.571,
    d: "M21.39 27.319l-.004-1.809"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4c4c4e",
    strokeWidth: 0.571,
    d: "M21.182 27.299l.32-1.779"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4e4f50",
    strokeWidth: 0.571,
    d: "M21.006 27.254l.574-1.714"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#515153",
    strokeWidth: 0.571,
    d: "M20.854 27.192l.777-1.635"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#535456",
    strokeWidth: 0.571,
    d: "M20.719 27.117l.945-1.542"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#565658",
    strokeWidth: 0.571,
    d: "M20.596 27.032l1.091-1.445"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#58595b",
    strokeWidth: 0.571,
    d: "M20.482 26.936l1.22-1.337"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5b5c5e",
    strokeWidth: 0.571,
    d: "M20.378 26.829l1.337-1.219"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5d5e60",
    strokeWidth: 0.571,
    d: "M20.28 26.709l1.449-1.084"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5f6163",
    strokeWidth: 0.571,
    d: "M20.192 26.577l1.55-.934"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#626365",
    strokeWidth: 0.571,
    d: "M20.114 26.426l1.643-.758"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#646568",
    strokeWidth: 0.571,
    d: "M20.051 26.262l1.721-.558"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#66686a",
    strokeWidth: 0.571,
    d: "M20.006 26.08l1.779-.331"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#696a6c",
    strokeWidth: 0.571,
    d: "M19.985 25.883l1.807-.078"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6b6c6f",
    strokeWidth: 0.571,
    d: "M19.985 25.79l1.809-.017"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6d6f71",
    strokeWidth: 0.571,
    d: "M19.985 25.727l1.81-.016"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6f7173",
    strokeWidth: 0.571,
    d: "M19.986 25.667l1.81-.018"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#717376",
    strokeWidth: 0.571,
    d: "M19.987 25.606l1.809-.019"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#747578",
    strokeWidth: 0.571,
    d: "M19.988 25.543l1.809-.017"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.571,
    d: "M19.988 25.483l1.81-.02"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 1.712,
    d: "M12.141 25.676l-1.809-.009"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#151515",
    strokeWidth: 1.675,
    d: "M12.14 25.731l-1.809.003"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#161516",
    strokeWidth: 1.638,
    d: "M12.139 25.786l-1.807.013"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#171718",
    strokeWidth: 1.601,
    d: "M12.138 25.84l-1.806.026"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#181818",
    strokeWidth: 1.564,
    d: "M12.137 25.889l-1.804.05"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#191819",
    strokeWidth: 1.528,
    d: "M12.125 26.102l-1.794-.189"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#1a191a",
    strokeWidth: 1.491,
    d: "M12.082 26.319l-1.744-.46"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#1a1a1b",
    strokeWidth: 1.454,
    d: "M12.003 26.532l-1.642-.748"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#1b1b1c",
    strokeWidth: 1.417,
    d: "M11.887 26.727l-1.483-1.023"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#1c1c1d",
    strokeWidth: 1.38,
    d: "M11.743 26.895l-1.282-1.266"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#1d1d1e",
    strokeWidth: 1.344,
    d: "M11.582 27.029l-1.061-1.456"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#1e1e1e",
    strokeWidth: 1.307,
    d: "M11.417 27.125l-.84-1.592"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#1e1e1f",
    strokeWidth: 1.27,
    d: "M11.256 27.193l-.634-1.685"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#1f1f20",
    strokeWidth: 1.233,
    d: "M11.104 27.235l-.449-1.743"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#202021",
    strokeWidth: 1.196,
    d: "M10.961 27.26l-.285-1.778"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#212122",
    strokeWidth: 1.16,
    d: "M10.827 27.27l-.136-1.795"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#222122",
    strokeWidth: 1.123,
    d: "M10.702 27.268l.001-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#222223",
    strokeWidth: 1.086,
    d: "M10.581 27.258l.135-1.795"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#232324",
    strokeWidth: 1.049,
    d: "M10.463 27.239l.273-1.78"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#242425",
    strokeWidth: 1.012,
    d: "M10.34 27.209l.434-1.748"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#252525",
    strokeWidth: 0.976,
    d: "M10.246 27.177l.553-1.714"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#252526",
    strokeWidth: 0.939,
    d: "M10.176 27.146l.602-1.698"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#262627",
    strokeWidth: 0.902,
    d: "M10.104 27.111l.638-1.685"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#272728",
    strokeWidth: 0.865,
    d: "M10.025 27.069l.676-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#272728",
    strokeWidth: 0.828,
    d: "M9.941 27.023l.725-1.651"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#292829",
    strokeWidth: 0.791,
    d: "M9.852 26.969l.791-1.621"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#29292a",
    strokeWidth: 0.755,
    d: "M9.811 26.94l.789-1.621"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#2a292a",
    strokeWidth: 0.718,
    d: "M9.782 26.917l.755-1.641"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#2a2a2b",
    strokeWidth: 0.681,
    d: "M9.736 26.883l.736-1.65"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#2b2a2c",
    strokeWidth: 0.644,
    d: "M9.685 26.846l.72-1.656"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#2c2c2d",
    strokeWidth: 0.607,
    d: "M9.635 26.812l.713-1.661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.591 26.784l.713-1.664m-.713 1.662l.713-1.662",
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#2c2c2d",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#333234",
    strokeWidth: 0.571,
    d: "M9.399 26.651l.8-1.62"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#39383a",
    strokeWidth: 0.571,
    d: "M9.213 26.51l.874-1.576"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#3e3d3f",
    strokeWidth: 0.571,
    d: "M9.029 26.365l.94-1.536"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#424143",
    strokeWidth: 0.571,
    d: "M8.85 26.213l.998-1.498"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#454446",
    strokeWidth: 0.571,
    d: "M8.674 26.059l1.05-1.459"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#484749",
    strokeWidth: 0.571,
    d: "M8.502 25.904l1.099-1.425"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4a4a4d",
    strokeWidth: 0.571,
    d: "M8.336 25.748l1.14-1.392"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4d4e50",
    strokeWidth: 0.571,
    d: "M8.174 25.593l1.179-1.36"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#505052",
    strokeWidth: 0.571,
    d: "M8.018 25.442l1.214-1.332"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#535355",
    strokeWidth: 0.571,
    d: "M7.868 25.295l1.247-1.305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.726 25.155l1.276-1.282m-1.276 1.282l1.276-1.282",
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#555658",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#56575a",
    strokeWidth: 0.571,
    d: "M7.571 24.997l1.281-1.277"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#57585a",
    strokeWidth: 0.571,
    d: "M7.418 24.836l1.285-1.271"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#58595c",
    strokeWidth: 0.571,
    d: "M7.265 24.671l1.292-1.262"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5a5b5d",
    strokeWidth: 0.571,
    d: "M7.112 24.503l1.301-1.253"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5b5c5e",
    strokeWidth: 0.571,
    d: "M6.962 24.333l1.312-1.244"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5c5d5f",
    strokeWidth: 0.571,
    d: "M6.813 24.158l1.325-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5d5e60",
    strokeWidth: 0.571,
    d: "M6.668 23.979l1.338-1.214"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5e5f61",
    strokeWidth: 0.571,
    d: "M6.525 23.798l1.356-1.196"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5f6062",
    strokeWidth: 0.571,
    d: "M6.387 23.613l1.373-1.176"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#606163",
    strokeWidth: 0.571,
    d: "M6.251 23.425l1.393-1.154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12 23.233l1.416-1.127M6.12 23.232l1.416-1.126",
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#616264",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#626365",
    strokeWidth: 0.571,
    d: "M5.984 23.021l1.455-1.074"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#636466",
    strokeWidth: 0.571,
    d: "M5.854 22.806l1.491-1.024"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#646568",
    strokeWidth: 0.571,
    d: "M5.731 22.588l1.521-.977"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#656668",
    strokeWidth: 0.571,
    d: "M5.613 22.369l1.55-.932"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#666769",
    strokeWidth: 0.571,
    d: "M5.502 22.147l1.573-.889"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#67686a",
    strokeWidth: 0.571,
    d: "M5.395 21.924l1.595-.849"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#68696b",
    strokeWidth: 0.571,
    d: "M5.292 21.701l1.616-.81"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#696a6c",
    strokeWidth: 0.571,
    d: "M5.194 21.478l1.634-.774"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6a6b6d",
    strokeWidth: 0.571,
    d: "M5.101 21.256l1.65-.74"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6b6c6e",
    strokeWidth: 0.571,
    d: "M5.011 21.034l1.664-.707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.925 20.814l1.678-.679m-1.678.679l1.678-.679",
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6c6d6f",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6c6d70",
    strokeWidth: 0.571,
    d: "M4.842 20.59l1.69-.641"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6c6e70",
    strokeWidth: 0.571,
    d: "M4.762 20.362l1.705-.603"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6d6e71",
    strokeWidth: 0.571,
    d: "M4.687 20.132l1.717-.567"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6d6f71",
    strokeWidth: 0.571,
    d: "M4.614 19.899l1.73-.53"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6e6f72",
    strokeWidth: 0.571,
    d: "M4.547 19.665l1.74-.494"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6e7072",
    strokeWidth: 0.571,
    d: "M4.483 19.428l1.75-.457"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6f7073",
    strokeWidth: 0.571,
    d: "M4.425 19.19l1.76-.419"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6f7173",
    strokeWidth: 0.571,
    d: "M4.371 18.952l1.768-.382"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#707174",
    strokeWidth: 0.571,
    d: "M4.321 18.712l1.776-.343"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#707274",
    strokeWidth: 0.571,
    d: "M4.276 18.472l1.784-.304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.236 18.232l1.79-.264m-1.79.264l1.79-.264",
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#717275",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#717375",
    strokeWidth: 0.571,
    d: "M4.21 18.057l1.793-.242"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#727376",
    strokeWidth: 0.571,
    d: "M4.187 17.881l1.794-.221"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#727476",
    strokeWidth: 0.571,
    d: "M4.164 17.703l1.798-.199"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#727477",
    strokeWidth: 0.571,
    d: "M4.145 17.524l1.799-.177"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#737577",
    strokeWidth: 0.571,
    d: "M4.127 17.343l1.802-.154"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#747578",
    strokeWidth: 0.571,
    d: "M4.111 17.162l1.804-.13"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#747678",
    strokeWidth: 0.571,
    d: "M4.1 16.98l1.805-.106"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#757679",
    strokeWidth: 0.571,
    d: "M4.089 16.797l1.807-.081"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#757779",
    strokeWidth: 0.571,
    d: "M4.082 16.614l1.808-.055"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#76777a",
    strokeWidth: 0.571,
    d: "M4.077 16.43l1.809-.028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.708 7.053l.654-1.389M4.076 16.247h1.809",
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#747678",
    strokeWidth: 0.571,
    d: "M10.762 7.076l.589-1.415"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#727376",
    strokeWidth: 0.571,
    d: "M10.805 7.093l.548-1.43"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#707174",
    strokeWidth: 0.571,
    d: "M10.839 7.105l.526-1.435"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6e6f71",
    strokeWidth: 0.571,
    d: "M10.866 7.114l.521-1.435"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6c6d6f",
    strokeWidth: 0.571,
    d: "M10.886 7.121l.531-1.43"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#696b6d",
    strokeWidth: 0.571,
    d: "M10.899 7.125l.556-1.418"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#67696b",
    strokeWidth: 0.571,
    d: "M10.905 7.127l.595-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#656669",
    strokeWidth: 0.571,
    d: "M10.905 7.126l.647-1.375"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#636467",
    strokeWidth: 0.571,
    d: "M10.897 7.122l.712-1.341"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#616264",
    strokeWidth: 0.571,
    d: "M10.884 7.112l.788-1.294"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5f6062",
    strokeWidth: 0.571,
    d: "M10.864 7.099l.875-1.236"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5c5d5f",
    strokeWidth: 0.571,
    d: "M10.839 7.078l.97-1.159"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5a5b5d",
    strokeWidth: 0.571,
    d: "M10.811 7.05l1.069-1.065"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#58585b",
    strokeWidth: 0.571,
    d: "M10.779 7.016l1.169-.953"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#555658",
    strokeWidth: 0.571,
    d: "M10.751 6.974l1.262-.822"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#535356",
    strokeWidth: 0.571,
    d: "M10.726 6.929l1.342-.678"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#515153",
    strokeWidth: 0.571,
    d: "M10.706 6.882l1.408-.525"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4e4f50",
    strokeWidth: 0.571,
    d: "M10.693 6.837l1.454-.37"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4c4c4e",
    strokeWidth: 0.571,
    d: "M10.687 6.797l1.481-.219"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#49494b",
    strokeWidth: 0.571,
    d: "M10.683 6.754l1.495-.069"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#474749",
    strokeWidth: 0.571,
    d: "M10.686 6.781l1.492-.068"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#444446",
    strokeWidth: 0.571,
    d: "M10.688 6.808l1.491-.066"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#424143",
    strokeWidth: 0.571,
    d: "M10.689 6.835l1.49-.064"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#3e3e3f",
    strokeWidth: 0.571,
    d: "M10.692 6.863L12.18 6.8"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#3a393b",
    strokeWidth: 0.571,
    d: "M10.694 6.89l1.487-.061"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#343435",
    strokeWidth: 0.571,
    d: "M10.697 6.917l1.484-.059"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#2f2f30",
    strokeWidth: 0.571,
    d: "M10.699 6.944l1.482-.056"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#29292a",
    strokeWidth: 0.571,
    d: "M10.701 6.972l1.481-.055"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#232324",
    strokeWidth: 0.571,
    d: "M10.704 6.999l1.479-.054"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#1c1c1d",
    strokeWidth: 0.571,
    d: "M10.706 7.026l1.478-.052"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 0.571,
    d: "M10.709 7.053l1.475-.05"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.571,
    d: "M21.985 6.841l-1.809.006"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#757779",
    strokeWidth: 0.571,
    d: "M21.982 6.771l-1.808.011"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#757679",
    strokeWidth: 0.571,
    d: "M21.979 6.701l-1.808.017"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#747678",
    strokeWidth: 0.571,
    d: "M21.976 6.632l-1.807.023"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#747578",
    strokeWidth: 0.571,
    d: "M21.972 6.661l-1.797-.193"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#737577",
    strokeWidth: 0.571,
    d: "M21.962 6.703l-1.753-.442"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#727476",
    strokeWidth: 0.571,
    d: "M21.944 6.749l-1.673-.682"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#727376",
    strokeWidth: 0.571,
    d: "M21.922 6.792l-1.567-.902"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#717375",
    strokeWidth: 0.571,
    d: "M21.896 6.829l-1.438-1.096"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#717275",
    strokeWidth: 0.571,
    d: "M21.871 6.856l-1.298-1.257"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#707174",
    strokeWidth: 0.571,
    d: "M21.849 6.876l-1.156-1.388"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6f7173",
    strokeWidth: 0.571,
    d: "M21.829 6.89l-1.013-1.495"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6f7073",
    strokeWidth: 0.571,
    d: "M21.813 6.9l-.872-1.582"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6e7072",
    strokeWidth: 0.571,
    d: "M21.798 6.908l-.735-1.651"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6e6f72",
    strokeWidth: 0.571,
    d: "M21.78 6.915l-.592-1.707"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6d6f71",
    strokeWidth: 0.571,
    d: "M21.756 6.922l-.443-1.752"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6d6e70",
    strokeWidth: 0.571,
    d: "M21.753 6.923l-.28-1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6c6d70",
    strokeWidth: 0.571,
    d: "M21.73 6.926l-.088-1.803"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6b6d6f",
    strokeWidth: 0.571,
    d: "M21.693 6.927l.12-1.803"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6b6c6f",
    strokeWidth: 0.571,
    d: "M21.652 6.923l.332-1.776"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6a6c6e",
    strokeWidth: 0.571,
    d: "M21.617 6.916l.526-1.728"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6a6b6d",
    strokeWidth: 0.571,
    d: "M21.596 6.911l.688-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#696a6d",
    strokeWidth: 0.571,
    d: "M21.598 6.914l.804-1.618"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#686a6c",
    strokeWidth: 0.571,
    d: "M21.638 6.938l.843-1.599"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#68696b",
    strokeWidth: 0.571,
    d: "M21.68 6.962l.877-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#67696b",
    strokeWidth: 0.571,
    d: "M21.723 6.99l.903-1.565"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#67686a",
    strokeWidth: 0.571,
    d: "M21.769 7.021l.923-1.555"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#66676a",
    strokeWidth: 0.571,
    d: "M21.817 7.053l.938-1.545"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#656769",
    strokeWidth: 0.571,
    d: "M21.868 7.088l.945-1.541"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#656668",
    strokeWidth: 0.571,
    d: "M21.924 7.126l.944-1.541"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#646568",
    strokeWidth: 0.571,
    d: "M21.981 7.166l.941-1.545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.044 7.208l.927-1.553m-.927 1.553l.927-1.553",
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#636567",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#626366",
    strokeWidth: 0.571,
    d: "M22.17 7.299l.984-1.517"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#616264",
    strokeWidth: 0.571,
    d: "M22.298 7.397l1.033-1.484"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#606163",
    strokeWidth: 0.571,
    d: "M22.429 7.5l1.077-1.452"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5f6062",
    strokeWidth: 0.571,
    d: "M22.56 7.609l1.116-1.421"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5d5e60",
    strokeWidth: 0.571,
    d: "M22.691 7.723l1.151-1.395"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5c5d5f",
    strokeWidth: 0.571,
    d: "M22.823 7.84l1.181-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5b5c5e",
    strokeWidth: 0.571,
    d: "M22.955 7.959l1.206-1.347"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5a5a5d",
    strokeWidth: 0.571,
    d: "M23.086 8.081l1.228-1.326"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#58595b",
    strokeWidth: 0.571,
    d: "M23.216 8.204l1.249-1.308"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#57575a",
    strokeWidth: 0.571,
    d: "M23.344 8.327l1.264-1.292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.47 8.449l1.278-1.279M23.47 8.449l1.278-1.279",
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#555658",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#545557",
    strokeWidth: 0.571,
    d: "M23.669 8.647l1.314-1.241"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#535356",
    strokeWidth: 0.571,
    d: "M23.86 8.851l1.351-1.203"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#525254",
    strokeWidth: 0.571,
    d: "M24.046 9.059l1.384-1.164"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#515153",
    strokeWidth: 0.571,
    d: "M24.224 9.271l1.417-1.125"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4f5052",
    strokeWidth: 0.571,
    d: "M24.396 9.487l1.447-1.084"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4e4e50",
    strokeWidth: 0.571,
    d: "M24.561 9.708l1.476-1.044"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4d4d4f",
    strokeWidth: 0.571,
    d: "M24.719 9.934l1.505-1.003"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4c4c4e",
    strokeWidth: 0.571,
    d: "M24.871 10.163l1.531-.963"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4a4a4c",
    strokeWidth: 0.571,
    d: "M25.018 10.397l1.556-.922"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#49494b",
    strokeWidth: 0.571,
    d: "M25.158 10.636l1.579-.882"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#484749",
    strokeWidth: 0.571,
    d: "M25.293 10.879l1.602-.842"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#464648",
    strokeWidth: 0.571,
    d: "M25.423 11.126l1.62-.803"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#454546",
    strokeWidth: 0.571,
    d: "M25.547 11.378l1.639-.765"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#444345",
    strokeWidth: 0.571,
    d: "M25.665 11.634l1.656-.727"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#424244",
    strokeWidth: 0.571,
    d: "M25.778 11.895l1.672-.69"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#414142",
    strokeWidth: 0.571,
    d: "M25.882 12.147l1.686-.652"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#3f3f41",
    strokeWidth: 0.571,
    d: "M25.979 12.4l1.701-.615"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#3d3c3e",
    strokeWidth: 0.571,
    d: "M26.07 12.659l1.714-.576"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#3b3a3c",
    strokeWidth: 0.571,
    d: "M26.158 12.924l1.727-.539"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#383739",
    strokeWidth: 0.571,
    d: "M26.24 13.193l1.739-.5"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#353536",
    strokeWidth: 0.571,
    d: "M26.317 13.465l1.749-.461"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#333234",
    strokeWidth: 0.571,
    d: "M26.388 13.741l1.758-.422"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#302f30",
    strokeWidth: 0.571,
    d: "M26.452 14.019l1.769-.381"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#2d2d2e",
    strokeWidth: 0.571,
    d: "M26.511 14.299l1.775-.34"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#2a2a2b",
    strokeWidth: 0.571,
    d: "M26.562 14.58l1.784-.297"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#272728",
    strokeWidth: 0.571,
    d: "M26.605 14.861l1.791-.253"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#242324",
    strokeWidth: 0.571,
    d: "M26.643 15.142l1.796-.207"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 0.571,
    d: "M26.672 15.421l1.802-.158"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#1c1c1d",
    strokeWidth: 0.571,
    d: "M26.692 15.699l1.805-.108"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#181818",
    strokeWidth: 0.571,
    d: "M26.705 15.975l1.808-.056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.519 16.246h-1.81m0 0h1.81",
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#141414",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#131314",
    strokeWidth: 0.571,
    d: "M28.508 16.728l-1.807-.073"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#121213",
    strokeWidth: 0.571,
    d: "M28.479 17.208l-1.803-.146"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#121112",
    strokeWidth: 0.571,
    d: "M28.431 17.685l-1.796-.218"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#111",
    strokeWidth: 0.571,
    d: "M28.363 18.157l-1.786-.287"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#101010",
    strokeWidth: 0.571,
    d: "M28.278 18.626l-1.773-.356"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#0f0f0f",
    strokeWidth: 0.571,
    d: "M28.175 19.09l-1.759-.423"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#0e0e0e",
    strokeWidth: 0.571,
    d: "M28.055 19.549l-1.743-.489"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#0d0c0d",
    strokeWidth: 0.571,
    d: "M27.917 20.002l-1.723-.553"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#0c0b0c",
    strokeWidth: 0.571,
    d: "M27.763 20.45l-1.701-.617"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#0a0a0b",
    strokeWidth: 0.571,
    d: "M27.593 20.89l-1.677-.678M27.407 21.323l-1.651-.738"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#09090a",
    strokeWidth: 0.571,
    d: "M27.206 21.749l-1.624-.797"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#080808",
    strokeWidth: 0.571,
    d: "M26.99 22.167l-1.594-.855"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#070707",
    strokeWidth: 0.571,
    d: "M26.759 22.576l-1.563-.911"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#060606",
    strokeWidth: 0.571,
    d: "M26.515 22.977l-1.531-.967"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#050505",
    strokeWidth: 0.571,
    d: "M26.256 23.367l-1.494-1.019"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 0.571,
    d: "M25.983 23.748l-1.457-1.072"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#030303",
    strokeWidth: 0.571,
    d: "M25.698 24.118l-1.418-1.124"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#020202",
    strokeWidth: 0.571,
    d: "M25.4 24.477l-1.376-1.174"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#010101",
    strokeWidth: 0.571,
    d: "M25.09 24.825l-1.333-1.223"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.571,
    d: "M24.768 25.161l-1.289-1.271"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#252525",
    strokeWidth: 0.571,
    d: "M12.48 11.572l-1.776-.344"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#2a2a2b",
    strokeWidth: 0.571,
    d: "M12.478 11.597l-1.777-.344"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#302f30",
    strokeWidth: 0.571,
    d: "M12.475 11.623l-1.776-.345"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#353436",
    strokeWidth: 0.571,
    d: "M12.49 11.503l-1.808-.046"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#3a393b",
    strokeWidth: 0.571,
    d: "M12.485 11.384l-1.791.255"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#3e3d3f",
    strokeWidth: 0.571,
    d: "M12.45 11.23l-1.702.614"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#414143",
    strokeWidth: 0.571,
    d: "M12.37 11.066l-1.517.984"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#444345",
    strokeWidth: 0.571,
    d: "M12.255 10.924L11 12.227"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#464648",
    strokeWidth: 0.571,
    d: "M12.132 10.824l-.969 1.528"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#48484a",
    strokeWidth: 0.571,
    d: "M12.026 10.766l-.712 1.663"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4b4b4d",
    strokeWidth: 0.571,
    d: "M11.949 10.736l-.506 1.737"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4d4d4f",
    strokeWidth: 0.571,
    d: "M11.901 10.722l-.353 1.774"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4f4f51",
    strokeWidth: 0.571,
    d: "M11.878 10.715l-.246 1.792"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#515254",
    strokeWidth: 0.571,
    d: "M11.875 10.712l-.177 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#545456",
    strokeWidth: 0.571,
    d: "M11.89 10.71l-.138 1.804"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#565658",
    strokeWidth: 0.571,
    d: "M11.92 10.709l-.127 1.805"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#58595b",
    strokeWidth: 0.571,
    d: "M11.962 10.709l-.14 1.804"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5a5b5d",
    strokeWidth: 0.571,
    d: "M12.07 10.721l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5c5d5f",
    strokeWidth: 0.571,
    d: "M12.096 10.723l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5e5f61",
    strokeWidth: 0.571,
    d: "M12.121 10.725l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#606164",
    strokeWidth: 0.571,
    d: "M12.147 10.727l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#626366",
    strokeWidth: 0.571,
    d: "M12.172 10.729l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#646668",
    strokeWidth: 0.571,
    d: "M12.198 10.731l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#66686a",
    strokeWidth: 0.571,
    d: "M12.224 10.733l-.299 1.785"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#686a6c",
    strokeWidth: 0.571,
    d: "M12.249 10.735l-.299 1.785"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6a6c6e",
    strokeWidth: 0.571,
    d: "M12.274 10.737l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6c6e70",
    strokeWidth: 0.571,
    d: "M12.299 10.739l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6e7072",
    strokeWidth: 0.571,
    d: "M12.324 10.742l-.298 1.783"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#707274",
    strokeWidth: 0.571,
    d: "M12.35 10.744l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#727476",
    strokeWidth: 0.571,
    d: "M12.376 10.746l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#747678",
    strokeWidth: 0.571,
    d: "M12.401 10.748l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.571,
    d: "M12.427 10.75l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 0.571,
    d: "M20.94 20.468l-.324 1.149"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#29292a",
    strokeWidth: 0.571,
    d: "M20.955 20.466l-.279 1.154"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#313031",
    strokeWidth: 0.571,
    d: "M20.987 20.468l-.264 1.151"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#383839",
    strokeWidth: 0.571,
    d: "M21.025 20.472l-.267 1.145"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#3f3f41",
    strokeWidth: 0.571,
    d: "M21.07 20.479l-.292 1.135"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#434344",
    strokeWidth: 0.571,
    d: "M21.125 20.492l-.342 1.116"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#474648",
    strokeWidth: 0.571,
    d: "M21.193 20.514l-.424 1.083"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4a4a4c",
    strokeWidth: 0.571,
    d: "M21.273 20.548l-.537 1.03"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#4e4e50",
    strokeWidth: 0.571,
    d: "M21.363 20.603l-.675.942"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#515153",
    strokeWidth: 0.571,
    d: "M21.452 20.678l-.816.82"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#545557",
    strokeWidth: 0.571,
    d: "M21.529 20.766l-.938.677"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#58585b",
    strokeWidth: 0.571,
    d: "M21.586 20.859l-1.025.536"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5b5c5e",
    strokeWidth: 0.571,
    d: "M21.625 20.945l-1.081.415"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#5e5f61",
    strokeWidth: 0.571,
    d: "M21.649 21.021l-1.113.324"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#616264",
    strokeWidth: 0.571,
    d: "M21.666 21.088l-1.132.261"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#646568",
    strokeWidth: 0.571,
    d: "M21.676 21.151l-1.143.219"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#67696b",
    strokeWidth: 0.571,
    d: "M21.684 21.21l-1.152.196"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6a6c6e",
    strokeWidth: 0.571,
    d: "M21.688 21.269l-1.157.185"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#6d6f71",
    strokeWidth: 0.571,
    d: "M21.688 21.303l-1.159.202"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#707274",
    strokeWidth: 0.571,
    d: "M21.688 21.322l-1.159.23"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#737577",
    strokeWidth: 0.571,
    d: "M21.688 21.341l-1.159.258"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "none",
    stroke: "#76787a",
    strokeWidth: 0.571,
    d: "M21.688 21.359l-1.158.287"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M11.159 18.467v-4.441c0-.273.221-.493.492-.493h9.223c.271 0 .491.22.491.493v4.441a.492.492 0 0 1-.491.493h-9.223a.493.493 0 0 1-.492-.493m-4.273-2.221c0-2.718 1.07-5.182 2.809-6.984a15.197 15.197 0 0 0-.179 2.383v9.204c0 .856.063 1.666.179 2.382a10.024 10.024 0 0 1-2.809-6.985m16.124 4.603v-9.204c0-.857-.065-1.667-.181-2.383a10.026 10.026 0 0 1 2.811 6.984c0 2.719-1.071 5.183-2.811 6.985.115-.716.181-1.526.181-2.382M21.365 6.615v4.781a.492.492 0 0 1-.491.492h-9.223a.492.492 0 0 1-.492-.492V6.615a.246.246 0 0 0-.376-.21 11.5 11.5 0 0 0-5.543 9.841c0 4.172 2.221 7.826 5.543 9.842a.256.256 0 0 0 .128.035.246.246 0 0 0 .248-.246v-4.78c0-.273.221-.494.492-.494h9.223c.271 0 .491.221.491.494v4.78c0 .137.111.246.246.246a.257.257 0 0 0 .129-.035 11.497 11.497 0 0 0 5.542-9.842c0-4.171-2.219-7.823-5.542-9.841a.247.247 0 0 0-.375.21M2.192 16.246c0-7.771 6.299-14.069 14.07-14.069 7.77 0 14.07 6.298 14.07 14.069 0 7.772-6.301 14.071-14.07 14.071-7.771 0-14.07-6.299-14.07-14.071m-1.311 0c0 8.482 6.899 15.383 15.382 15.383 8.48 0 15.381-6.901 15.381-15.383 0-8.481-6.9-15.382-15.381-15.382C7.78.864.881 7.765.881 16.246"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.88 16.247c0 8.48 6.9 15.382 15.383 15.382 8.481 0 15.382-6.901 15.382-15.382 0-8.482-6.9-15.382-15.382-15.382C7.78.865.88 7.765.88 16.247m21.95 6.984c.115-.716.179-1.527.179-2.383v-9.205c0-.856-.063-1.665-.179-2.382a10.032 10.032 0 0 1 2.81 6.985 10.03 10.03 0 0 1-2.81 6.985m-1.465-4.763c0 .272-.22.493-.493.493h-9.22a.493.493 0 0 1-.493-.493v-4.442c0-.273.22-.493.493-.493h9.22c.273 0 .493.22.493.493v4.442zm-14.48-2.221c0-2.718 1.071-5.183 2.811-6.985-.115.717-.18 1.526-.18 2.382v9.205c0 .856.064 1.667.18 2.383a10.025 10.025 0 0 1-2.811-6.985M21.74 6.405a.247.247 0 0 0-.375.21v4.781c0 .272-.22.493-.493.493h-9.22a.493.493 0 0 1-.493-.493V6.615a.247.247 0 0 0-.375-.21 11.498 11.498 0 0 0-5.543 9.842 11.5 11.5 0 0 0 5.543 9.842.247.247 0 0 0 .375-.211v-4.78c0-.272.22-.493.493-.493h9.22c.273 0 .493.221.493.493v4.78a.247.247 0 0 0 .375.211 11.5 11.5 0 0 0 5.543-9.842c0-4.172-2.22-7.825-5.543-9.842m-5.477 23.912c-7.771 0-14.07-6.299-14.07-14.07s6.299-14.07 14.07-14.07 14.069 6.299 14.069 14.07-6.299 14.07-14.069 14.07",
    clipPath: "url(#n)",
    fill: "#dae0e3"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M11.159 18.467v-4.441c0-.273.221-.493.492-.493h9.223c.271 0 .491.22.491.493v4.441a.492.492 0 0 1-.491.493h-9.223a.493.493 0 0 1-.492-.493m-4.273-2.221c0-2.718 1.07-5.182 2.809-6.984a15.197 15.197 0 0 0-.179 2.383v9.204c0 .856.063 1.666.179 2.382a10.024 10.024 0 0 1-2.809-6.985m16.124 4.603v-9.204c0-.857-.065-1.667-.181-2.383a10.026 10.026 0 0 1 2.811 6.984c0 2.719-1.071 5.183-2.811 6.985.115-.716.181-1.526.181-2.382M21.365 6.615v4.781a.492.492 0 0 1-.491.492h-9.223a.492.492 0 0 1-.492-.492V6.615a.246.246 0 0 0-.376-.21 11.5 11.5 0 0 0-5.543 9.841c0 4.172 2.221 7.826 5.543 9.842a.256.256 0 0 0 .128.035.246.246 0 0 0 .248-.246v-4.78c0-.273.221-.494.492-.494h9.223c.271 0 .491.221.491.494v4.78c0 .137.111.246.246.246a.257.257 0 0 0 .129-.035 11.497 11.497 0 0 0 5.542-9.842c0-4.171-2.219-7.823-5.542-9.841a.247.247 0 0 0-.375.21M2.192 16.246c0-7.771 6.299-14.069 14.07-14.069 7.77 0 14.07 6.298 14.07 14.069 0 7.772-6.301 14.071-14.07 14.071-7.771 0-14.07-6.299-14.07-14.071m-1.311 0c0 8.482 6.899 15.383 15.382 15.383 8.48 0 15.381-6.901 15.381-15.383 0-8.481-6.9-15.382-15.381-15.382C7.78.864.881 7.765.881 16.246"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M.881.864h30.763v30.765H.881z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 129,
    height: 129,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBLAEsAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAALWAAAEewAABan/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAIUAhQMBIgACEQEDEQH/ xACZAAACAwEBAAAAAAAAAAAAAAAABAEDBQIGAQEBAQAAAAAAAAAAAAAAAAAAAQIQAAICAQEHBAID AAAAAAAAAAABAgMRBBAgMDETFAUSNCUGQSRAIRURAAECAwUGAwgDAAAAAAAAAAABAhExsiGhMgNz IDBAUWFjEIFkseESIkKiM7NiE3QSAQEBAAAAAAAAAAAAAAAAAIEwQP/aAAwDAQACEQMRAAAA9jCk azpzRMt5TJaVBdFQWlQWxVBatKKNmeUzycpoTx3NTMSAAAAEBAHCD2fZyciX1SvWvak5L1MEvRAS QEwQETwVZzOfrNpURcmxm2bDuM6ur0mxLYQSyQEwVnSsKXPKXSeo4Ukr2Lv4SXN5d9muxkXy61mV 2unznxDtKlVXq1rWdrliNlpNaWJ6PIMyt6m5ps54GukpHYTBmqqQO7Su/tlbBszdHN9ArNefX2lt ZyK9SpM7l/mkh0RTtvtVbmr4WbYemljRJZAl4XbDLo2ubMPjc5sxZ2JMizVslzmmQ56CUAAAAAAA AAAAAAAAAP/aAAgBAgABBQDCxvJGEfjeWxct5bFy3Utq5bMGDG4uXATM7uRsztyZMmTPE//aAAgB AwABBQDLzvNsyz87z2Pmt57HzT3W9r5mTJkzuPnwGjG7gSMbcGDBgxxP/9oACAEBAAEFANb5KWlv r8nKYtU2u5Z3DO4Z3DOuzrs67O4Z3DO4Z3LJatpWeVlAXmJdDzHvaELkLhT5XoXsfMe9oYuQuFPl exex808a2iRB5XDteI3yE/0fOPGuomUyyuHfMvkKXx/2CWPIUzKbCMsrbnZncnLCusLpil8b9llj yNNhTaVWiknwJSSV1pdYXWEZ/FfanjyVVhVaVXFdxGxMzsyZG0idqRZcW2ltpbYRb/xvtazr4ycX VaV3FdxC8jeK8647yV5O8suLLSy0bcnGPw32eOdbKAm4uu0hcQvI3ivOuO8leTuJ3E7T+5OECMPi PsMPVq51koDi0KxojcK8V51x3kryVw5tii2RgQrFX8X5mv1X2Uk6iVY4DgYkjMj1SMyMNigRrI1k KiukVX6Gvq9c7aCygnSSqHUOo6Z0zpiqFURqIUldBVQdF9q0pK7RplumaJ6cnQSoHQOk6IqRUEaC FBDTlWmbdWkjEwsbJ1wmrNEmWaSUSWmHph6Y7cWmFpiOmK9HJlejjEjGMVvuuuQ9NUx6Os7KAtHW LTVIUIR/j//aAAgBAgIGPwDCxYsWLs//2gAIAQMCBj8AgRIkSJE2f//aAAgBAQEGPwBuUmWj4tR0 Ywmqpy6H40Tz9xhvMN5hvMJhMJhvMJhMJhvMN5H4bz8SL5+4XO/qSKPRkPi5oqxl0GaaVOE3qijt ZtLhmmlThN6oo7WbS4ZppU4TfKO120OGaSVOEIb5+u2hxl6Tan8A9fUMoeZei2p/APX1LKHmUvZb W/gMxfUs/W8y9FtT9qexPaf/AKWfreZa9pKn7UyZPwntPT1DKHjF7aVO8bNme4cneav2OGr/AAT2 u4Byd1q/a4R0PphepLfSFSH1ItykFSKEWW9CRIkS2pEiRBEiRfavIhCzl4wckT5V8lLUJEiRIkSJ FjT5lj0Qg1IJuLWoSgTMVxMlEsaicP8A/9k=",
    transform: "matrix(.24 0 0 .24 .88 .864)",
    overflow: "visible"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M1.049 16.246c0-8.388 6.825-15.212 15.214-15.212 8.388 0 15.212 6.824 15.212 15.212 0 8.389-6.824 15.213-15.212 15.213-8.389 0-15.214-6.824-15.214-15.213m-.347 0c0 8.579 6.981 15.559 15.561 15.559 8.578 0 15.558-6.98 15.558-15.559 0-8.579-6.979-15.558-15.558-15.558S.702 7.667.702 16.246"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.263.601C7.734.601.6 7.719.6 16.247",
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.913
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#b8c2c8",
    strokeWidth: 0.571,
    d: "M1.164 22.273l1.088-.493"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#b6c0c6",
    strokeWidth: 0.571,
    d: "M1.276 22.543l1.079-.511"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#b4bdc4",
    strokeWidth: 0.571,
    d: "M1.394 22.812l1.07-.53"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#b1bbc2",
    strokeWidth: 0.571,
    d: "M1.518 23.079l1.06-.547"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#afb9bf",
    strokeWidth: 0.571,
    d: "M1.646 23.343l1.052-.562"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#acb7bd",
    strokeWidth: 0.571,
    d: "M1.778 23.604l1.045-.578"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#aab5bb",
    strokeWidth: 0.571,
    d: "M1.916 23.862l1.037-.592"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#a8b3b9",
    strokeWidth: 0.571,
    d: "M2.058 24.116l1.029-.605"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#a5b0b7",
    strokeWidth: 0.571,
    d: "M2.203 24.368l1.021-.618"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#a3aeb5",
    strokeWidth: 0.571,
    d: "M2.352 24.616l1.014-.631"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#a1acb3",
    strokeWidth: 0.571,
    d: "M2.504 24.862l1.007-.643"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#9faab1",
    strokeWidth: 0.571,
    d: "M2.658 25.102l1-.652"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#5c6870",
    strokeWidth: 0.571,
    d: "M10.933 31.616l.392-1.127"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#5a676e",
    strokeWidth: 0.571,
    d: "M11.39 31.766l.354-1.141"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#58656c",
    strokeWidth: 0.571,
    d: "M11.854 31.903l.318-1.151"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#56636b",
    strokeWidth: 0.571,
    d: "M12.325 32.025l.282-1.16"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#546169",
    strokeWidth: 0.571,
    d: "M12.803 32.133l.246-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#535f67",
    strokeWidth: 0.571,
    d: "M13.286 32.227l.211-1.176"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#515d64",
    strokeWidth: 0.571,
    d: "M13.774 32.307l.175-1.182"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#4f5b63",
    strokeWidth: 0.571,
    d: "M14.267 32.373l.14-1.187"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#4d5961",
    strokeWidth: 0.571,
    d: "M14.763 32.424l.104-1.189"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#4b575f",
    strokeWidth: 0.571,
    d: "M15.261 32.46l.07-1.192"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#49555d",
    strokeWidth: 0.571,
    d: "M15.761 32.483l.035-1.193"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M16.263 32.491v-1.196"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.571,
    d: "M16.264.004l-.003 1.194"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#f9fafb",
    strokeWidth: 0.571,
    d: "M16.573.007l-.028 1.194"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#f5f6f7",
    strokeWidth: 0.571,
    d: "M16.883.017l-.052 1.192"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#f1f3f5",
    strokeWidth: 0.571,
    d: "M17.191.032l-.075 1.193"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#eef1f3",
    strokeWidth: 0.571,
    d: "M17.499.054l-.098 1.19"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#eaeef0",
    strokeWidth: 0.571,
    d: "M17.806.082l-.12 1.188"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#e7ebee",
    strokeWidth: 0.571,
    d: "M18.11.115l-.141 1.186"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#e4e9eb",
    strokeWidth: 0.571,
    d: "M18.414.154l-.163 1.183"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#e1e6e9",
    strokeWidth: 0.571,
    d: "M18.714.198l-.184 1.18"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#dee3e7",
    strokeWidth: 0.571,
    d: "M19.013.247l-.205 1.177"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#dbe0e4",
    strokeWidth: 0.571,
    d: "M19.308.301l-.225 1.173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6.359l-.245 1.169M19.6.359l-.245 1.169",
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#d8dee2",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#d5dbdf",
    strokeWidth: 0.571,
    d: "M19.888.422l-.263 1.165"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#d2d9dd",
    strokeWidth: 0.571,
    d: "M20.176.491l-.28 1.161"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#cfd6db",
    strokeWidth: 0.571,
    d: "M20.463.564l-.297 1.158"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#ccd4d8",
    strokeWidth: 0.571,
    d: "M20.749.644l-.313 1.151"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#c9d1d6",
    strokeWidth: 0.571,
    d: "M21.034.727l-.331 1.148"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#c6cfd3",
    strokeWidth: 0.571,
    d: "M21.316.816l-.346 1.142"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#c3ccd1",
    strokeWidth: 0.571,
    d: "M21.597.91l-.366 1.137"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#c1c9cf",
    strokeWidth: 0.571,
    d: "M21.875 1.008l-.382 1.131"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#bec7cd",
    strokeWidth: 0.571,
    d: "M22.149 1.111l-.4 1.125"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#bbc4ca",
    strokeWidth: 0.571,
    d: "M22.421 1.219l-.418 1.119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.252 2.443l.438-1.111m-.001 0l-.438 1.111",
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#b8c2c8",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#b5bfc5",
    strokeWidth: 0.571,
    d: "M22.501 2.557l.46-1.102"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#b2bcc3",
    strokeWidth: 0.571,
    d: "M22.762 2.681l.481-1.092"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#afb9c0",
    strokeWidth: 0.571,
    d: "M23.031 2.816l.505-1.082"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#acb7bd",
    strokeWidth: 0.571,
    d: "M23.311 2.962l.528-1.07"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#aab4bb",
    strokeWidth: 0.571,
    d: "M23.597 3.12l.55-1.059"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#a7b1b8",
    strokeWidth: 0.571,
    d: "M23.889 3.289l.575-1.046"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#a4afb6",
    strokeWidth: 0.571,
    d: "M24.187 3.469l.599-1.033"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#a1acb3",
    strokeWidth: 0.571,
    d: "M24.487 3.66l.625-1.018"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#9eaab1",
    strokeWidth: 0.571,
    d: "M24.791 3.863l.649-1.002"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#9ca7ae",
    strokeWidth: 0.571,
    d: "M25.096 4.078l.676-.984"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#99a4ab",
    strokeWidth: 0.571,
    d: "M25.401 4.305l.703-.965"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#96a2a9",
    strokeWidth: 0.571,
    d: "M25.706 4.543l.731-.945"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#939fa6",
    strokeWidth: 0.571,
    d: "M26.008 4.793l.759-.922"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#919da4",
    strokeWidth: 0.571,
    d: "M26.308 5.056l.787-.898"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#8e9aa2",
    strokeWidth: 0.571,
    d: "M26.603 5.33l.815-.872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.892 5.617l.844-.845m-.844.845l.845-.845",
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#8b979f",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#89959c",
    strokeWidth: 0.571,
    d: "M27.198 5.933l.869-.819"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#86929a",
    strokeWidth: 0.571,
    d: "M27.496 6.258l.893-.793"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#839097",
    strokeWidth: 0.571,
    d: "M27.785 6.593l.915-.767"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#818d95",
    strokeWidth: 0.571,
    d: "M28.065 6.938l.938-.739"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#7e8a92",
    strokeWidth: 0.571,
    d: "M28.336 7.292l.959-.712"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#7b8890",
    strokeWidth: 0.571,
    d: "M28.597 7.654l.978-.684"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#79868d",
    strokeWidth: 0.571,
    d: "M28.848 8.024l.998-.655"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#76838a",
    strokeWidth: 0.571,
    d: "M29.088 8.403l1.016-.626"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#748088",
    strokeWidth: 0.571,
    d: "M29.318 8.79l1.036-.597"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#717e86",
    strokeWidth: 0.571,
    d: "M29.537 9.184l1.052-.565"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#6e7b83",
    strokeWidth: 0.571,
    d: "M29.745 9.584l1.068-.533"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#6c7981",
    strokeWidth: 0.571,
    d: "M29.942 9.993l1.082-.504"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#69767e",
    strokeWidth: 0.571,
    d: "M30.127 10.407l1.098-.471"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#67747b",
    strokeWidth: 0.571,
    d: "M30.3 10.828l1.111-.438"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#647179",
    strokeWidth: 0.571,
    d: "M30.46 11.254l1.124-.404"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#626f76",
    strokeWidth: 0.571,
    d: "M30.608 11.686l1.135-.37"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#5f6c74",
    strokeWidth: 0.571,
    d: "M30.744 12.124l1.146-.337"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#5d6971",
    strokeWidth: 0.571,
    d: "M30.866 12.565l1.156-.299"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#5a676e",
    strokeWidth: 0.571,
    d: "M30.975 13.013l1.165-.265"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#57646c",
    strokeWidth: 0.571,
    d: "M31.07 13.464l1.172-.228"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#556169",
    strokeWidth: 0.571,
    d: "M31.151 13.919l1.179-.191"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#525e66",
    strokeWidth: 0.571,
    d: "M31.219 14.378l1.183-.153"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#4f5c63",
    strokeWidth: 0.571,
    d: "M31.271 14.841l1.189-.116"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#4d5960",
    strokeWidth: 0.571,
    d: "M31.31 15.307l1.191-.078"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#4a565e",
    strokeWidth: 0.571,
    d: "M31.332 15.775l1.194-.039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.34 16.246h1.194m-1.194 0h1.194",
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#46525a",
    strokeWidth: 0.571,
    d: "M31.332 16.72l1.194.038"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#465259",
    strokeWidth: 0.571,
    d: "M31.31 17.193l1.192.075"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#455159",
    strokeWidth: 0.571,
    d: "M31.272 17.662l1.19.113"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#455158",
    strokeWidth: 0.571,
    d: "M31.222 18.129l1.184.15"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#445057",
    strokeWidth: 0.571,
    d: "M31.155 18.593l1.18.186M31.076 19.053l1.174.222"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#434f56",
    strokeWidth: 0.571,
    d: "M30.982 19.51l1.166.257"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#424e55",
    strokeWidth: 0.571,
    d: "M30.875 19.962l1.158.293M30.755 20.41l1.149.327"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#414d54",
    strokeWidth: 0.571,
    d: "M30.622 20.853l1.138.362"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#414c53",
    strokeWidth: 0.571,
    d: "M30.476 21.291l1.127.395"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#404c53",
    strokeWidth: 0.571,
    d: "M30.317 21.722l1.116.429"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3f4b52",
    strokeWidth: 0.571,
    d: "M30.146 22.148l1.102.461"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3f4a52",
    strokeWidth: 0.571,
    d: "M29.963 22.568l1.089.494"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3e4a51",
    strokeWidth: 0.571,
    d: "M29.769 22.981l1.072.526"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3e4950",
    strokeWidth: 0.571,
    d: "M29.562 23.387l1.056.556"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3d4850",
    strokeWidth: 0.571,
    d: "M29.345 23.786l1.04.588"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3c484f",
    strokeWidth: 0.571,
    d: "M29.116 24.176l1.021.619"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3c474e",
    strokeWidth: 0.571,
    d: "M28.877 24.559l1.003.649"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3b474e",
    strokeWidth: 0.571,
    d: "M28.627 24.932l.982.68"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3b464d",
    strokeWidth: 0.571,
    d: "M28.366 25.297l.962.708"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3a454c",
    strokeWidth: 0.571,
    d: "M28.096 25.653l.94.737"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#39454b",
    strokeWidth: 0.571,
    d: "M27.815 26l.917.766"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#39444b",
    strokeWidth: 0.571,
    d: "M27.526 26.336l.893.793"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#38434a",
    strokeWidth: 0.571,
    d: "M27.228 26.663l.868.82M27.761 27.827l-.842-.849m0 0l.842.849M27.419 28.155l-.815-.874"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#39444b",
    strokeWidth: 0.571,
    d: "M27.066 28.473l-.787-.898"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#39454b",
    strokeWidth: 0.571,
    d: "M26.703 28.781l-.758-.923"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3a454c",
    strokeWidth: 0.571,
    d: "M26.33 29.079l-.73-.946"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3b464d",
    strokeWidth: 0.571,
    d: "M25.946 29.366l-.701-.968"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3b474e",
    strokeWidth: 0.571,
    d: "M25.554 29.641l-.672-.988"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3c474e",
    strokeWidth: 0.571,
    d: "M25.152 29.905l-.641-1.008"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3c484f",
    strokeWidth: 0.571,
    d: "M24.742 30.158l-.612-1.027"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3d4850",
    strokeWidth: 0.571,
    d: "M24.323 30.399l-.581-1.043"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3e4950",
    strokeWidth: 0.571,
    d: "M23.896 30.627l-.549-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3e4a51",
    strokeWidth: 0.571,
    d: "M23.462 30.844l-.52-1.075"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3f4a52",
    strokeWidth: 0.571,
    d: "M23.021 31.049l-.488-1.09"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#3f4b52",
    strokeWidth: 0.571,
    d: "M22.571 31.241l-.455-1.104"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#404c53",
    strokeWidth: 0.571,
    d: "M22.116 31.42l-.424-1.117"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#414c53",
    strokeWidth: 0.571,
    d: "M21.654 31.586l-.389-1.128"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#414d54",
    strokeWidth: 0.571,
    d: "M21.187 31.739l-.357-1.14"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#424e55",
    strokeWidth: 0.571,
    d: "M20.714 31.878l-.323-1.149M20.235 32.004l-.289-1.158"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#434f56",
    strokeWidth: 0.571,
    d: "M19.752 32.117l-.255-1.167"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#445057",
    strokeWidth: 0.571,
    d: "M19.265 32.213l-.22-1.171M18.772 32.297l-.184-1.179"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#455158",
    strokeWidth: 0.571,
    d: "M18.277 32.366l-.149-1.185"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#455159",
    strokeWidth: 0.571,
    d: "M17.778 32.42l-.114-1.188"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#465259",
    strokeWidth: 0.571,
    d: "M17.276 32.458l-.077-1.192"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#46525a",
    strokeWidth: 0.571,
    d: "M16.771 32.483l-.041-1.195"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M16.265 32.491l-.004-1.196"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#8b979f",
    strokeWidth: 0.571,
    d: "M4.797 27.715l.84-.849"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#88949c",
    strokeWidth: 0.571,
    d: "M5.12 28.03l.817-.871"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#859299",
    strokeWidth: 0.571,
    d: "M5.452 28.336l.794-.892"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#828f96",
    strokeWidth: 0.571,
    d: "M5.794 28.635l.77-.912"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#7f8b93",
    strokeWidth: 0.571,
    d: "M6.145 28.926l.746-.931"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#7c8990",
    strokeWidth: 0.571,
    d: "M6.503 29.208l.723-.953"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#79868e",
    strokeWidth: 0.571,
    d: "M6.871 29.481l.696-.971"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#76838a",
    strokeWidth: 0.571,
    d: "M7.246 29.744l.67-.988"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#738088",
    strokeWidth: 0.571,
    d: "M7.63 29.997l.642-1.006"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#707d85",
    strokeWidth: 0.571,
    d: "M8.02 30.241l.615-1.025"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#6d7a82",
    strokeWidth: 0.571,
    d: "M8.417 30.473l.586-1.041"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#6a777f",
    strokeWidth: 0.571,
    d: "M8.821 30.694l.557-1.057"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#68747c",
    strokeWidth: 0.571,
    d: "M9.232 30.903l.527-1.072"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#647179",
    strokeWidth: 0.571,
    d: "M9.649 31.101l.495-1.087"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#626e76",
    strokeWidth: 0.571,
    d: "M10.071 31.286l.462-1.102"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#5f6b73",
    strokeWidth: 0.571,
    d: "M10.5 31.458l.428-1.116"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#5c6870",
    strokeWidth: 0.571,
    d: "M10.933 31.616l.392-1.128"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#9faab1",
    strokeWidth: 0.571,
    d: "M2.658 25.102l1-.652"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#9da8af",
    strokeWidth: 0.571,
    d: "M2.829 25.358l.985-.676"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#9ba7ae",
    strokeWidth: 0.571,
    d: "M3.006 25.61l.971-.695"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#99a5ac",
    strokeWidth: 0.571,
    d: "M3.188 25.859l.956-.716"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#97a3aa",
    strokeWidth: 0.571,
    d: "M3.375 26.104l.941-.733"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#96a2a9",
    strokeWidth: 0.571,
    d: "M3.566 26.348l.928-.752"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#94a0a7",
    strokeWidth: 0.571,
    d: "M3.763 26.586l.913-.769"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#939ea5",
    strokeWidth: 0.571,
    d: "M3.963 26.821l.898-.786"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#919ca4",
    strokeWidth: 0.571,
    d: "M4.167 27.051l.884-.802"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#8f9ba2",
    strokeWidth: 0.571,
    d: "M4.374 27.278l.87-.819"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#8d99a1",
    strokeWidth: 0.571,
    d: "M4.584 27.499l.855-.834"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#8b979f",
    strokeWidth: 0.571,
    d: "M4.798 27.715l.84-.848"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#d8dee2",
    strokeWidth: 0.571,
    d: "M.272 19.346l1.173-.226"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#d5dbdf",
    strokeWidth: 0.571,
    d: "M.33 19.622l1.166-.259"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#d2d9dd",
    strokeWidth: 0.571,
    d: "M.393 19.896l1.159-.288"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#cfd6db",
    strokeWidth: 0.571,
    d: "M.462 20.17l1.15-.316"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#ccd4d8",
    strokeWidth: 0.571,
    d: "M.535 20.442l1.144-.343"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#c9d1d6",
    strokeWidth: 0.571,
    d: "M.614 20.712l1.136-.367"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#c6cfd3",
    strokeWidth: 0.571,
    d: "M.697 20.979l1.128-.392"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#c3ccd1",
    strokeWidth: 0.571,
    d: "M.784 21.245l1.12-.414"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#c1c9cf",
    strokeWidth: 0.571,
    d: "M.875 21.506l1.112-.435"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#bec7cd",
    strokeWidth: 0.571,
    d: "M.969 21.766l1.103-.455"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#bbc4ca",
    strokeWidth: 0.571,
    d: "M1.065 22.021l1.096-.474"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#b8c2c8",
    strokeWidth: 0.571,
    d: "M1.164 22.272l1.088-.492"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.571,
    d: "M.002 16.247l1.193-.001"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#f9fafb",
    strokeWidth: 0.571,
    d: "M.004 16.53l1.193-.017"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#f5f6f7",
    strokeWidth: 0.571,
    d: "M.01 16.814l1.194-.035"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#f1f3f5",
    strokeWidth: 0.571,
    d: "M.02 17.099l1.193-.052"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#eef1f3",
    strokeWidth: 0.571,
    d: "M.034 17.383l1.194-.071"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#eaeef0",
    strokeWidth: 0.571,
    d: "M.054 17.667l1.19-.09"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#e7ebee",
    strokeWidth: 0.571,
    d: "M.077 17.952l1.189-.111"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#e4e9eb",
    strokeWidth: 0.571,
    d: "M.105 18.234l1.188-.131"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#e1e6e9",
    strokeWidth: 0.571,
    d: "M.14 18.515l1.183-.154"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#dee3e7",
    strokeWidth: 0.571,
    d: "M.179 18.795l1.18-.177"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#dbe0e4",
    strokeWidth: 0.571,
    d: "M.223 19.072l1.176-.201"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#d8dee2",
    strokeWidth: 0.571,
    d: "M.272 19.347l1.174-.227"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "M2.358 16.249c0-7.668 6.237-13.907 13.904-13.907 7.666 0 13.904 6.239 13.904 13.907 0 7.665-6.238 13.902-13.904 13.902-7.666 0-13.904-6.237-13.904-13.902m-.345-.003c0 7.857 6.393 14.25 14.25 14.25 7.856 0 14.249-6.394 14.249-14.25 0-7.857-6.393-14.249-14.249-14.249-7.858 0-14.25 6.392-14.25 14.249"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M16.263 3.041V1.847"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#4a565e",
    strokeWidth: 0.571,
    d: "M16.774 3.05l.043-1.193"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#4d5a61",
    strokeWidth: 0.571,
    d: "M17.279 3.079l.087-1.191"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#505d64",
    strokeWidth: 0.571,
    d: "M17.775 3.126l.132-1.187"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#536067",
    strokeWidth: 0.571,
    d: "M18.266 3.191l.173-1.182"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#56636b",
    strokeWidth: 0.571,
    d: "M18.748 3.274l.219-1.174"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#59666d",
    strokeWidth: 0.571,
    d: "M19.225 3.375l.26-1.165"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#5c6970",
    strokeWidth: 0.571,
    d: "M19.694 3.494l.303-1.155"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#5f6c73",
    strokeWidth: 0.571,
    d: "M20.158 3.629l.345-1.143"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#626f76",
    strokeWidth: 0.571,
    d: "M20.616 3.782l.386-1.131"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#657179",
    strokeWidth: 0.571,
    d: "M21.07 3.951l.424-1.116"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#68747c",
    strokeWidth: 0.571,
    d: "M21.519 4.137l.46-1.102"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3c474f",
    strokeWidth: 0.571,
    d: "M10.915 4.162l-.484-1.093"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3d4850",
    strokeWidth: 0.571,
    d: "M11.37 3.97l-.444-1.109"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3e4a51",
    strokeWidth: 0.571,
    d: "M11.829 3.795l-.401-1.125"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3f4b52",
    strokeWidth: 0.571,
    d: "M12.295 3.639L11.936 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#404c53",
    strokeWidth: 0.571,
    d: "M12.767 3.5l-.316-1.152"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#414d54",
    strokeWidth: 0.571,
    d: "M13.244 3.379l-.269-1.163"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#424e55",
    strokeWidth: 0.571,
    d: "M13.729 3.277l-.225-1.173"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#434f56",
    strokeWidth: 0.571,
    d: "M14.221 3.193l-.18-1.181"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#445057",
    strokeWidth: 0.571,
    d: "M14.719 3.126l-.134-1.187"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#455158",
    strokeWidth: 0.571,
    d: "M15.226 3.079l-.09-1.191"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#465259",
    strokeWidth: 0.571,
    d: "M15.739 3.051l-.044-1.194"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M16.263 3.041V1.847"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#38434a",
    strokeWidth: 0.571,
    d: "M6.928 6.892l-.845-.846M7.246 6.583l-.814-.873"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#38444b",
    strokeWidth: 0.571,
    d: "M7.574 6.288l-.786-.9"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#39444b",
    strokeWidth: 0.571,
    d: "M7.91 6.004l-.755-.926M8.254 5.732l-.723-.951"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3a454c",
    strokeWidth: 0.571,
    d: "M8.607 5.472l-.691-.974M8.969 5.225l-.657-.998"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3b464d",
    strokeWidth: 0.571,
    d: "M9.34 4.989L8.717 3.97M9.719 4.765l-.588-1.04"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3b474e",
    strokeWidth: 0.571,
    d: "M10.108 4.552l-.553-1.059"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3c474e",
    strokeWidth: 0.571,
    d: "M10.506 4.352l-.517-1.078"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3c474f",
    strokeWidth: 0.571,
    d: "M10.914 4.162l-.482-1.093"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#38434a",
    strokeWidth: 0.571,
    d: "M6.928 6.892l-.845-.846"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#39444b",
    strokeWidth: 0.571,
    d: "M6.62 7.208l-.87-.817"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3a454c",
    strokeWidth: 0.571,
    d: "M6.324 7.533l-.896-.79"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3b464d",
    strokeWidth: 0.571,
    d: "M6.04 7.866l-.922-.76"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3c474e",
    strokeWidth: 0.571,
    d: "M5.768 8.207l-.946-.729"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3d484f",
    strokeWidth: 0.571,
    d: "M5.508 8.557l-.971-.698"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3e4950",
    strokeWidth: 0.571,
    d: "M5.259 8.915l-.993-.665"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#3f4a52",
    strokeWidth: 0.571,
    d: "M5.022 9.281l-1.015-.63"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#404b52",
    strokeWidth: 0.571,
    d: "M4.797 9.657l-1.035-.596"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#414d54",
    strokeWidth: 0.571,
    d: "M4.584 10.042l-1.056-.561"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#424e55",
    strokeWidth: 0.571,
    d: "M4.382 10.436L3.31 9.911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.104 10.35l1.089.49m-.001-.001l-1.09-.489M2.89 10.85l1.106.447",
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#434f56",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#445057",
    strokeWidth: 0.571,
    d: "M2.695 11.356l1.123.406M2.52 11.871l1.138.361M2.364 12.392l1.153.316"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#455158",
    strokeWidth: 0.571,
    d: "M2.229 12.921l1.163.271M2.113 13.457l1.173.225"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#465259",
    strokeWidth: 0.571,
    d: "M2.019 14.001l1.18.178M1.944 14.552l1.188.131"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#46525a",
    strokeWidth: 0.571,
    d: "M1.892 15.11l1.19.085"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#47535a",
    strokeWidth: 0.571,
    d: "M1.859 15.676l1.195.039"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M1.849 16.25l1.194-.008"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#b8c2c8",
    strokeWidth: 0.571,
    d: "M10.834 29.565l.452-1.106"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#bec7cd",
    strokeWidth: 0.571,
    d: "M11.298 29.746l.416-1.121"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#c3ccd1",
    strokeWidth: 0.571,
    d: "M11.768 29.911l.378-1.133"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#c9d1d6",
    strokeWidth: 0.571,
    d: "M12.242 30.061l.339-1.145"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#cfd6db",
    strokeWidth: 0.571,
    d: "M12.723 30.194l.298-1.156"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#d5dbdf",
    strokeWidth: 0.571,
    d: "M13.209 30.31l.257-1.166"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#dbe0e4",
    strokeWidth: 0.571,
    d: "M13.701 30.409l.215-1.174"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#e1e6e9",
    strokeWidth: 0.571,
    d: "M14.2 30.491l.172-1.181"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#e7ebee",
    strokeWidth: 0.571,
    d: "M14.705 30.555l.129-1.187"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#eef1f3",
    strokeWidth: 0.571,
    d: "M15.218 30.602l.086-1.191"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#f5f6f7",
    strokeWidth: 0.571,
    d: "M15.736 30.63l.043-1.194"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.571,
    d: "M16.263 30.639v-1.193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.061 16.246c0 7.701-6.098 13.796-13.799 13.796",
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.913
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#94a0a7",
    strokeWidth: 0.571,
    d: "M6.001 26.322l.841-.848"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#97a3aa",
    strokeWidth: 0.571,
    d: "M6.383 26.697l.809-.877"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#9aa6ad",
    strokeWidth: 0.571,
    d: "M6.775 27.055l.78-.904"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#9ea9b0",
    strokeWidth: 0.571,
    d: "M7.18 27.399l.746-.933"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#a1acb3",
    strokeWidth: 0.571,
    d: "M7.596 27.725l.713-.959"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#a4afb6",
    strokeWidth: 0.571,
    d: "M8.023 28.037l.677-.984"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#a7b2b9",
    strokeWidth: 0.571,
    d: "M8.463 28.332l.641-1.007"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#abb5bc",
    strokeWidth: 0.571,
    d: "M8.913 28.611l.605-1.03"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#aeb8be",
    strokeWidth: 0.571,
    d: "M9.376 28.874l.567-1.051"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#b1bbc2",
    strokeWidth: 0.571,
    d: "M9.851 29.12l.528-1.071"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#b5bec5",
    strokeWidth: 0.571,
    d: "M10.337 29.35l.489-1.088"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#b8c2c8",
    strokeWidth: 0.571,
    d: "M10.834 29.565l.452-1.107"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#68747c",
    strokeWidth: 0.571,
    d: "M2.927 21.606l1.103-.457"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#6b7880",
    strokeWidth: 0.571,
    d: "M3.131 22.088l1.087-.494"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#6f7c84",
    strokeWidth: 0.571,
    d: "M3.35 22.56l1.068-.532"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#738088",
    strokeWidth: 0.571,
    d: "M3.583 23.021l1.05-.571"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#77848b",
    strokeWidth: 0.571,
    d: "M3.832 23.471l1.028-.607"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#7b888f",
    strokeWidth: 0.571,
    d: "M4.096 23.91l1.006-.644"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#7f8b93",
    strokeWidth: 0.571,
    d: "M4.375 24.338l.981-.68"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#839097",
    strokeWidth: 0.571,
    d: "M4.67 24.756l.954-.716"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#87939b",
    strokeWidth: 0.571,
    d: "M4.979 25.164l.928-.751"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#8b979f",
    strokeWidth: 0.571,
    d: "M5.305 25.561l.899-.786"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#909ca3",
    strokeWidth: 0.571,
    d: "M5.646 25.947l.87-.819"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#94a0a7",
    strokeWidth: 0.571,
    d: "M6.001 26.322l.841-.849"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M1.849 16.25l1.194-.007"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#4a565e",
    strokeWidth: 0.571,
    d: "M1.858 16.77l1.194-.053"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#4d5a61",
    strokeWidth: 0.571,
    d: "M1.888 17.283l1.19-.097"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#505d64",
    strokeWidth: 0.571,
    d: "M1.937 17.79l1.185-.144"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#536067",
    strokeWidth: 0.571,
    d: "M2.003 18.288l1.179-.188"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#56636b",
    strokeWidth: 0.571,
    d: "M2.087 18.78l1.172-.231"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#59666d",
    strokeWidth: 0.571,
    d: "M2.188 19.266l1.163-.273"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#5c6970",
    strokeWidth: 0.571,
    d: "M2.306 19.745l1.152-.313"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#5f6c73",
    strokeWidth: 0.571,
    d: "M2.438 20.219l1.142-.352"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#626f76",
    strokeWidth: 0.571,
    d: "M2.587 20.687l1.129-.389"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#657179",
    strokeWidth: 0.571,
    d: "M2.75 21.148l1.117-.423"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.519 4.137l.461-1.101M2.927 21.606l1.103-.457",
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#68747c",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#6b777f",
    strokeWidth: 0.571,
    d: "M21.936 4.327l.496-1.088"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#6e7b83",
    strokeWidth: 0.571,
    d: "M22.343 4.526l.531-1.069"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#717e86",
    strokeWidth: 0.571,
    d: "M22.741 4.738l.566-1.052"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#748189",
    strokeWidth: 0.571,
    d: "M23.129 4.961l.601-1.032"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#77848c",
    strokeWidth: 0.571,
    d: "M23.508 5.196l.638-1.01"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#7b878f",
    strokeWidth: 0.571,
    d: "M23.878 5.443l.672-.987"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#7e8a92",
    strokeWidth: 0.571,
    d: "M24.238 5.702l.707-.964"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#818e95",
    strokeWidth: 0.571,
    d: "M24.59 5.973l.741-.937"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#859198",
    strokeWidth: 0.571,
    d: "M24.932 6.257l.774-.909"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#88949c",
    strokeWidth: 0.571,
    d: "M25.265 6.554l.807-.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.588 6.865l.839-.849m-.839.849l.839-.849",
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#8b979f",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#8f9ba2",
    strokeWidth: 0.571,
    d: "M25.925 7.212l.87-.816"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#939fa6",
    strokeWidth: 0.571,
    d: "M26.245 7.572l.901-.783"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#97a3aa",
    strokeWidth: 0.571,
    d: "M26.55 7.943l.931-.748"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#9ba7ae",
    strokeWidth: 0.571,
    d: "M26.84 8.324l.958-.713"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#9faab1",
    strokeWidth: 0.571,
    d: "M27.116 8.717l.983-.678"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#a3aeb5",
    strokeWidth: 0.571,
    d: "M27.377 9.121l1.007-.642"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#a7b2b9",
    strokeWidth: 0.571,
    d: "M27.624 9.535l1.028-.607"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#acb6bc",
    strokeWidth: 0.571,
    d: "M27.857 9.96l1.048-.571"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#b0bac0",
    strokeWidth: 0.571,
    d: "M28.078 10.396l1.066-.538"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#b4bec4",
    strokeWidth: 0.571,
    d: "M28.285 10.843l1.082-.504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.576 10.829l-1.097.471m0-.001l1.097-.471",
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#b8c2c8",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#bec7cd",
    strokeWidth: 0.571,
    d: "M29.758 11.291l-1.112.435"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#c3ccd1",
    strokeWidth: 0.571,
    d: "M29.923 11.759l-1.127.396"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#c9d1d6",
    strokeWidth: 0.571,
    d: "M30.073 12.233l-1.14.356"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#cfd6db",
    strokeWidth: 0.571,
    d: "M30.207 12.712l-1.152.314"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#d5dbdf",
    strokeWidth: 0.571,
    d: "M30.324 13.197l-1.163.271"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#dbe0e4",
    strokeWidth: 0.571,
    d: "M30.425 13.688l-1.173.228"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#e1e6e9",
    strokeWidth: 0.571,
    d: "M30.507 14.187l-1.18.181"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#e7ebee",
    strokeWidth: 0.571,
    d: "M30.572 14.691l-1.186.137"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#eef1f3",
    strokeWidth: 0.571,
    d: "M30.619 15.202l-1.19.091"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#f5f6f7",
    strokeWidth: 0.571,
    d: "M30.647 15.72l-1.193.046"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.571,
    d: "M30.657 16.246h-1.194"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M23.066 9.762l.17.207a9.92 9.92 0 0 1 2.236 6.277 9.92 9.92 0 0 1-2.236 6.278l-.17.207-.513 1.028.22-.216a10.16 10.16 0 0 0 3.045-7.297c0-2.772-1.082-5.363-3.045-7.295l-.22-.216.513 1.027z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#8b979f",
    strokeWidth: 0.571,
    d: "M22.736 7.836l-1.035.911"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#8d99a0",
    strokeWidth: 0.571,
    d: "M22.974 8.172l-1.084.849"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#8e9aa2",
    strokeWidth: 0.571,
    d: "M23.273 8.622l-1.093.837"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#909ca3",
    strokeWidth: 0.571,
    d: "M23.536 9.022l-1.097.833"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#919da4",
    strokeWidth: 0.571,
    d: "M23.632 9.174l-1.05.892"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#939ea5",
    strokeWidth: 0.571,
    d: "M23.903 9.562l-1.082.853"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#94a0a7",
    strokeWidth: 0.571,
    d: "M24.087 9.833l-1.05.894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.571 16.247c-.106 1.303-.076 1.741-.485 2.963-.262.784-.794 1.96-1.263 2.644-.135.197-.276.429-.42.621-.327.436-.883 1.083-1.12 1.297",
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.598
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#94a0a7",
    strokeWidth: 0.571,
    d: "M23.038 10.726l1.049-.894"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#96a1a9",
    strokeWidth: 0.571,
    d: "M23.183 10.954l1.104-.857"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#97a3aa",
    strokeWidth: 0.571,
    d: "M23.319 11.19l1.156-.823"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#99a5ac",
    strokeWidth: 0.571,
    d: "M23.45 11.434l1.2-.793"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#9ba7ae",
    strokeWidth: 0.571,
    d: "M23.576 11.685l1.239-.768"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#9da8af",
    strokeWidth: 0.571,
    d: "M23.697 11.942l1.275-.749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.815 12.204l1.306-.736m-1.306.736l1.306-.736",
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#9faab1",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#a7b1b8",
    strokeWidth: 0.571,
    d: "M23.978 12.556l1.334-.687"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#aeb8bf",
    strokeWidth: 0.571,
    d: "M24.127 12.912l1.363-.634"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#b6c0c6",
    strokeWidth: 0.571,
    d: "M24.264 13.272l1.388-.577"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#bec7cd",
    strokeWidth: 0.571,
    d: "M24.387 13.637l1.415-.519"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#c6ced3",
    strokeWidth: 0.571,
    d: "M24.496 14.004l1.439-.456"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#ced6da",
    strokeWidth: 0.571,
    d: "M24.59 14.373l1.461-.389"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#d6dde1",
    strokeWidth: 0.571,
    d: "M24.668 14.745l1.48-.319"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#dfe4e8",
    strokeWidth: 0.571,
    d: "M24.729 15.119l1.498-.244"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#e8ecee",
    strokeWidth: 0.571,
    d: "M24.774 15.494l1.51-.167"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#f1f4f5",
    strokeWidth: 0.571,
    d: "M24.801 15.87l1.518-.085"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.571,
    d: "M24.809 16.247h1.524"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "M9.751 8.951a10.153 10.153 0 0 0-3.046 7.295c0 2.773 1.082 5.364 3.046 7.297l.219.216-.514-1.029-.169-.206a9.927 9.927 0 0 1-2.235-6.278c0-2.288.794-4.518 2.235-6.277l.169-.207.514-1.027-.219.216z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#3c474f",
    strokeWidth: 0.571,
    d: "M7.369 11.503l1.295.642"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#3d4850",
    strokeWidth: 0.571,
    d: "M7.181 11.907l1.324.587"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#3e4a51",
    strokeWidth: 0.571,
    d: "M7.009 12.318l1.351.532"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#3f4b52",
    strokeWidth: 0.571,
    d: "M6.854 12.736l1.375.475"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#404c53",
    strokeWidth: 0.571,
    d: "M6.718 13.16l1.397.418"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#414d54",
    strokeWidth: 0.571,
    d: "M6.6 13.589l1.416.36"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#424e55",
    strokeWidth: 0.571,
    d: "M6.498 14.023l1.433.3"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#434f56",
    strokeWidth: 0.571,
    d: "M6.415 14.462l1.447.241"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#445057",
    strokeWidth: 0.571,
    d: "M6.349 14.904l1.46.18"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#455158",
    strokeWidth: 0.571,
    d: "M6.302 15.35l1.469.12"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#465259",
    strokeWidth: 0.571,
    d: "M6.272 15.798l1.476.058"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M6.262 16.248l1.479-.004"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#839097",
    strokeWidth: 0.571,
    d: "M9.753 24.333l1.104-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#828e96",
    strokeWidth: 0.571,
    d: "M9.475 24.065l1.203-1.145"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#808d95",
    strokeWidth: 0.571,
    d: "M9.192 23.755l1.23-1.097"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#7f8b93",
    strokeWidth: 0.571,
    d: "M8.91 23.42l1.234-1.074"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#7e8a92",
    strokeWidth: 0.571,
    d: "M8.647 23.087l1.233-1.056"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#7c8991",
    strokeWidth: 0.571,
    d: "M8.405 22.757l1.251-1.017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19 22.438l1.24-1.015m-1.24 1.015l1.24-1.015",
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#7b888f",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#78848c",
    strokeWidth: 0.571,
    d: "M7.951 22.068l1.258-.967"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#758189",
    strokeWidth: 0.571,
    d: "M7.72 21.687l1.279-.911"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#717e86",
    strokeWidth: 0.571,
    d: "M7.5 21.294l1.303-.847"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#6e7b83",
    strokeWidth: 0.571,
    d: "M7.294 20.889l1.329-.774"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#6b7880",
    strokeWidth: 0.571,
    d: "M7.105 20.472l1.357-.694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.938 20.042l1.382-.602m-1.382.602l1.381-.602",
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#68747c",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#657179",
    strokeWidth: 0.571,
    d: "M6.822 19.711l1.401-.55"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#626f76",
    strokeWidth: 0.571,
    d: "M6.717 19.377l1.417-.498"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#5f6c73",
    strokeWidth: 0.571,
    d: "M6.622 19.039l1.432-.445"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#5c6970",
    strokeWidth: 0.571,
    d: "M6.538 18.698l1.443-.392"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#59666d",
    strokeWidth: 0.571,
    d: "M6.465 18.354l1.456-.337"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#56636b",
    strokeWidth: 0.571,
    d: "M6.402 18.008l1.465-.284"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#536067",
    strokeWidth: 0.571,
    d: "M6.352 17.659l1.471-.228"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#505d64",
    strokeWidth: 0.571,
    d: "M6.312 17.309l1.476-.173"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#4d5a61",
    strokeWidth: 0.571,
    d: "M6.283 16.956l1.481-.117"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#4a565e",
    strokeWidth: 0.571,
    d: "M6.267 16.603l1.481-.061"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M6.262 16.248l1.479-.004"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#3c474f",
    strokeWidth: 0.571,
    d: "M7.354 11.495l1.326.657"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#3c474e",
    strokeWidth: 0.571,
    d: "M7.534 11.146l1.298.705"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#3b474e",
    strokeWidth: 0.571,
    d: "M7.727 10.808l1.266.753"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#3b464d",
    strokeWidth: 0.571,
    d: "M7.93 10.48l1.235.799M8.146 10.16L9.35 11"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#3a454c",
    strokeWidth: 0.571,
    d: "M8.374 9.846l1.164.889M8.639 9.52l1.119.939"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#39444b",
    strokeWidth: 0.571,
    d: "M8.876 9.256l1.065.994M9.148 8.973l1.045 1.011"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#38444b",
    strokeWidth: 0.571,
    d: "M9.439 8.679l1.034 1.02"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "none",
    stroke: "#38434a",
    strokeWidth: 0.571,
    d: "M9.714 8.406l1.026 1.021M9.933 8.19l1.026 1.018"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M11.324 18.566v-4.639c0-.135.11-.245.245-.245h9.385c.136 0 .245.11.245.245v4.639a.245.245 0 0 1-.245.245h-9.385a.246.246 0 0 1-.245-.245m.245-5.229a.59.59 0 0 0-.59.59v4.439c0 .103.001.164.007.208l-.001-.001.001.001a.58.58 0 0 0 .583.582l9.385.001a.593.593 0 0 0 .591-.591v-4.639a.591.591 0 0 0-.591-.59h-9.385z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.194 18.585l.001-4.631c0-.169.074-.292.242-.292l9.497-.001",
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.913
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.23 14.263l.088 4.471c0 .11-.075.205-.145.205l-9.268-.06",
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.913
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M21.087 13.246l-.323 1.15"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#525e66",
    strokeWidth: 0.571,
    d: "M21.11 13.244l-.272 1.154"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#5c6870",
    strokeWidth: 0.571,
    d: "M21.157 13.248l-.264 1.148"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#65727a",
    strokeWidth: 0.571,
    d: "M21.214 13.257l-.29 1.135"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#6f7c84",
    strokeWidth: 0.571,
    d: "M21.287 13.274l-.358 1.11"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#79868e",
    strokeWidth: 0.571,
    d: "M21.383 13.309l-.483 1.057"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#839097",
    strokeWidth: 0.571,
    d: "M21.498 13.373l-.656.956"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#8e9aa1",
    strokeWidth: 0.571,
    d: "M21.614 13.471l-.841.795"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#98a4ab",
    strokeWidth: 0.571,
    d: "M21.707 13.591l-.986.605"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#a3aeb5",
    strokeWidth: 0.571,
    d: "M21.765 13.707l-1.072.436"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#afb9bf",
    strokeWidth: 0.571,
    d: "M21.799 13.808l-1.116.315"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#bbc4ca",
    strokeWidth: 0.571,
    d: "M21.817 13.895l-1.136.239"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#c6cfd4",
    strokeWidth: 0.571,
    d: "M21.828 13.974l-1.148.2"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#d3dade",
    strokeWidth: 0.571,
    d: "M21.834 14.052l-1.156.185"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#dfe4e8",
    strokeWidth: 0.571,
    d: "M21.835 14.089l-1.158.213"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#edf0f2",
    strokeWidth: 0.571,
    d: "M21.835 14.113l-1.158.25"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.571,
    d: "M21.835 14.138l-1.158.287"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M12.366 18.74l-1.776-.344"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#4d5960",
    strokeWidth: 0.571,
    d: "M12.363 18.767l-1.776-.345"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#525e66",
    strokeWidth: 0.571,
    d: "M12.36 18.793l-1.776-.344"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#57646b",
    strokeWidth: 0.571,
    d: "M12.376 18.663l-1.809-.023"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#5c6971",
    strokeWidth: 0.571,
    d: "M12.371 18.548l-1.789.265"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#616e76",
    strokeWidth: 0.571,
    d: "M12.337 18.402l-1.705.605"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#67737b",
    strokeWidth: 0.571,
    d: "M12.264 18.247l-1.535.957"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#6c7880",
    strokeWidth: 0.571,
    d: "M12.157 18.108l-1.292 1.267"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#707d85",
    strokeWidth: 0.571,
    d: "M12.04 18.007l-1.02 1.494"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#75828a",
    strokeWidth: 0.571,
    d: "M11.936 17.945l-.77 1.638"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#7b878f",
    strokeWidth: 0.571,
    d: "M11.854 17.911l-.56 1.72"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#808c94",
    strokeWidth: 0.571,
    d: "M11.801 17.894l-.402 1.764"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#859299",
    strokeWidth: 0.571,
    d: "M11.771 17.885l-.285 1.787"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#8a979e",
    strokeWidth: 0.571,
    d: "M11.761 17.881l-.204 1.797"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#909ca3",
    strokeWidth: 0.571,
    d: "M11.767 17.879l-.155 1.803"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#95a1a8",
    strokeWidth: 0.571,
    d: "M11.787 17.879l-.131 1.804"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#9ba7ae",
    strokeWidth: 0.571,
    d: "M11.82 17.878l-.13 1.804"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#a1acb3",
    strokeWidth: 0.571,
    d: "M11.864 17.879l-.149 1.803"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#a7b1b8",
    strokeWidth: 0.571,
    d: "M11.966 17.89l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#acb7bd",
    strokeWidth: 0.571,
    d: "M11.992 17.892l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#b3bcc3",
    strokeWidth: 0.571,
    d: "M12.019 17.895l-.298 1.783"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#b9c2c8",
    strokeWidth: 0.571,
    d: "M12.046 17.896l-.298 1.785"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#bfc8cd",
    strokeWidth: 0.571,
    d: "M12.072 17.898l-.298 1.785"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#c5cdd3",
    strokeWidth: 0.571,
    d: "M12.1 17.901l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#cbd3d7",
    strokeWidth: 0.571,
    d: "M12.126 17.903l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#d1d8dd",
    strokeWidth: 0.571,
    d: "M12.152 17.905l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#d8dee2",
    strokeWidth: 0.571,
    d: "M12.179 17.908l-.298 1.783"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#dee4e7",
    strokeWidth: 0.571,
    d: "M12.206 17.91l-.299 1.783"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#e6eaec",
    strokeWidth: 0.571,
    d: "M12.232 17.912l-.297 1.783"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#eceff1",
    strokeWidth: 0.571,
    d: "M12.259 17.914l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#f4f6f7",
    strokeWidth: 0.571,
    d: "M12.285 17.916l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.571,
    d: "M12.312 17.918l-.297 1.784"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M20.954 12.051a.591.591 0 0 0 .591-.589V6.615c0-.037.03-.067.066-.067l.035.009c3.418 2.075 5.457 5.697 5.457 9.689 0 3.993-2.039 7.615-5.457 9.69l-.035.008a.065.065 0 0 1-.066-.066V21.03a.59.59 0 0 0-.591-.588h-9.385a.59.59 0 0 0-.59.588v4.848c0 .039-.03.066-.067.066l-.034-.008c-3.417-2.075-5.457-5.697-5.457-9.69 0-3.992 2.04-7.614 5.457-9.689l.034-.009c.037 0 .067.03.067.067v4.847a.59.59 0 0 0 .59.589h9.385zm.245-5.436v4.847a.245.245 0 0 1-.245.245h-9.385a.245.245 0 0 1-.245-.245V6.615a.413.413 0 0 0-.626-.353c-3.521 2.138-5.623 5.87-5.623 9.984 0 4.115 2.103 7.846 5.623 9.985a.413.413 0 0 0 .626-.353V21.03c0-.133.11-.243.245-.243h9.385c.136 0 .245.11.245.243v4.848c0 .229.186.414.412.414.076 0 .15-.021.214-.061 3.521-2.139 5.624-5.87 5.624-9.985 0-4.114-2.103-7.846-5.624-9.984a.414.414 0 0 0-.626.353"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.421 25.678l.004-4.537c0-.098.053-.201.194-.201l9.282.003",
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 1.712
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 1.141,
    d: "M11.163 6.443v4.933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.309 6.157c-.063-.062-.289-.084-.386-.084-.062 0-.25.084-.305.118-.184.112-.334.199-.51.319-3.171 2.164-5.128 5.866-5.128 9.736",
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.027
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.399 6.092v5.188c0 .167.031.313-.136.313h-.85l-8.619-.003",
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.712
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M12.034 25.624l-1.808-.009"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#49555c",
    strokeWidth: 0.571,
    d: "M12.034 25.674l-1.808.003"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#4a575e",
    strokeWidth: 0.571,
    d: "M12.033 25.725l-1.807.014"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#4c5960",
    strokeWidth: 0.571,
    d: "M12.032 25.776l-1.806.025"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#4e5b62",
    strokeWidth: 0.571,
    d: "M12.031 25.827l-1.805.037"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#505c64",
    strokeWidth: 0.571,
    d: "M12.026 25.98l-1.801-.106"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#525e66",
    strokeWidth: 0.571,
    d: "M11.997 26.182l-1.769-.349"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#536068",
    strokeWidth: 0.571,
    d: "M11.938 26.383l-1.696-.614"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#556269",
    strokeWidth: 0.571,
    d: "M11.845 26.577l-1.572-.883"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#57636b",
    strokeWidth: 0.571,
    d: "M11.724 26.749l-1.405-1.129"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#58656d",
    strokeWidth: 0.571,
    d: "M11.581 26.895l-1.207-1.338"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#5a676e",
    strokeWidth: 0.571,
    d: "M11.429 27.006l-.999-1.497"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#5c6970",
    strokeWidth: 0.571,
    d: "M11.275 27.09l-.796-1.615"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#5e6a72",
    strokeWidth: 0.571,
    d: "M11.126 27.149l-.608-1.695"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#5f6c74",
    strokeWidth: 0.571,
    d: "M10.985 27.186l-.439-1.746"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#616e75",
    strokeWidth: 0.571,
    d: "M10.853 27.208l-.288-1.778"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#626f77",
    strokeWidth: 0.571,
    d: "M10.729 27.216l-.15-1.794"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#647179",
    strokeWidth: 0.571,
    d: "M10.61 27.216l-.02-1.799"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#66727a",
    strokeWidth: 0.571,
    d: "M10.497 27.208l.104-1.797"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#67747c",
    strokeWidth: 0.571,
    d: "M10.387 27.192l.232-1.785"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#69767e",
    strokeWidth: 0.571,
    d: "M10.274 27.167l.375-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#6b777f",
    strokeWidth: 0.571,
    d: "M10.164 27.133l.521-1.724"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#6c7981",
    strokeWidth: 0.571,
    d: "M10.066 27.094l.637-1.685"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#6e7b83",
    strokeWidth: 0.571,
    d: "M9.975 27.048l.733-1.647"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#6f7c84",
    strokeWidth: 0.571,
    d: "M9.892 26.999l.796-1.618"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#717e86",
    strokeWidth: 0.571,
    d: "M9.812 26.946l.83-1.602"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#738087",
    strokeWidth: 0.571,
    d: "M9.803 26.934l.779-1.629"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#748189",
    strokeWidth: 0.571,
    d: "M9.771 26.909l.75-1.642"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#76838a",
    strokeWidth: 0.571,
    d: "M9.726 26.875l.734-1.649"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#78848c",
    strokeWidth: 0.571,
    d: "M9.678 26.842l.72-1.658"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#79868e",
    strokeWidth: 0.571,
    d: "M9.631 26.809l.713-1.662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.591 26.784l.713-1.664m-.713 1.662l.713-1.662",
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#7b888f",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#7c8991",
    strokeWidth: 0.571,
    d: "M9.399 26.651l.8-1.62"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#7e8a92",
    strokeWidth: 0.571,
    d: "M9.213 26.51l.874-1.576"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#7f8c94",
    strokeWidth: 0.571,
    d: "M9.029 26.365l.94-1.536"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#818d95",
    strokeWidth: 0.571,
    d: "M8.85 26.213l.998-1.498"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#828f96",
    strokeWidth: 0.571,
    d: "M8.674 26.059l1.05-1.459"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#849098",
    strokeWidth: 0.571,
    d: "M8.502 25.904l1.099-1.425"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#859299",
    strokeWidth: 0.571,
    d: "M8.336 25.748l1.14-1.392"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#87939b",
    strokeWidth: 0.571,
    d: "M8.174 25.593l1.179-1.36"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#88949c",
    strokeWidth: 0.571,
    d: "M8.018 25.442l1.214-1.332"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#8a969e",
    strokeWidth: 0.571,
    d: "M7.868 25.295l1.247-1.305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.726 25.155l1.276-1.282m-1.276 1.282l1.276-1.282",
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#8b979f",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#8d99a1",
    strokeWidth: 0.571,
    d: "M7.571 24.997l1.281-1.277"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#8f9ba2",
    strokeWidth: 0.571,
    d: "M7.418 24.836l1.285-1.271"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#919ca4",
    strokeWidth: 0.571,
    d: "M7.265 24.671l1.292-1.262"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#939ea5",
    strokeWidth: 0.571,
    d: "M7.112 24.503l1.301-1.253"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#94a0a7",
    strokeWidth: 0.571,
    d: "M6.962 24.333l1.312-1.244"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#96a2a9",
    strokeWidth: 0.571,
    d: "M6.813 24.158l1.325-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#97a3aa",
    strokeWidth: 0.571,
    d: "M6.668 23.979l1.338-1.214"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#99a5ac",
    strokeWidth: 0.571,
    d: "M6.525 23.798l1.356-1.196"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#9ba7ae",
    strokeWidth: 0.571,
    d: "M6.387 23.613l1.373-1.176"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#9da8af",
    strokeWidth: 0.571,
    d: "M6.251 23.425l1.393-1.154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12 23.233l1.416-1.127M6.12 23.232l1.416-1.126",
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#9faab1",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a1acb3",
    strokeWidth: 0.571,
    d: "M5.984 23.021l1.455-1.074"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a3aeb5",
    strokeWidth: 0.571,
    d: "M5.854 22.806l1.491-1.024"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a5b0b7",
    strokeWidth: 0.571,
    d: "M5.731 22.588l1.521-.977"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a8b3b9",
    strokeWidth: 0.571,
    d: "M5.613 22.369l1.55-.932"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#aab5bb",
    strokeWidth: 0.571,
    d: "M5.502 22.147l1.573-.889"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#acb7bd",
    strokeWidth: 0.571,
    d: "M5.395 21.924l1.595-.849"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#afb9bf",
    strokeWidth: 0.571,
    d: "M5.292 21.701l1.616-.81"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#b1bbc2",
    strokeWidth: 0.571,
    d: "M5.194 21.478l1.634-.774"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#b4bdc4",
    strokeWidth: 0.571,
    d: "M5.101 21.256l1.65-.74"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#b6c0c6",
    strokeWidth: 0.571,
    d: "M5.011 21.034l1.664-.707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.925 20.814l1.678-.679m-1.678.679l1.678-.679",
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#b8c2c8",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#bbc4ca",
    strokeWidth: 0.571,
    d: "M4.842 20.59l1.69-.641"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#bec7cd",
    strokeWidth: 0.571,
    d: "M4.762 20.362l1.705-.603"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c1c9cf",
    strokeWidth: 0.571,
    d: "M4.687 20.132l1.717-.567"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c3ccd1",
    strokeWidth: 0.571,
    d: "M4.614 19.899l1.73-.53"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c6cfd3",
    strokeWidth: 0.571,
    d: "M4.547 19.665l1.74-.494"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c9d1d6",
    strokeWidth: 0.571,
    d: "M4.483 19.428l1.75-.457"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#ccd4d8",
    strokeWidth: 0.571,
    d: "M4.425 19.19l1.76-.419"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#cfd6db",
    strokeWidth: 0.571,
    d: "M4.371 18.952l1.768-.382"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#d2d9dd",
    strokeWidth: 0.571,
    d: "M4.321 18.712l1.776-.343"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#d5dbdf",
    strokeWidth: 0.571,
    d: "M4.276 18.472l1.784-.304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.236 18.232l1.79-.264m-1.79.264l1.79-.264",
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#d8dee2",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#dbe0e4",
    strokeWidth: 0.571,
    d: "M4.21 18.057l1.793-.242"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#dee3e7",
    strokeWidth: 0.571,
    d: "M4.187 17.881l1.794-.221"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#e1e6e9",
    strokeWidth: 0.571,
    d: "M4.164 17.703l1.798-.199"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#e4e9eb",
    strokeWidth: 0.571,
    d: "M4.145 17.524l1.799-.177"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#e7ebee",
    strokeWidth: 0.571,
    d: "M4.127 17.343l1.802-.154"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#eaeef0",
    strokeWidth: 0.571,
    d: "M4.111 17.162l1.804-.13"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#eef1f3",
    strokeWidth: 0.571,
    d: "M4.1 16.98l1.805-.106"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#f1f3f5",
    strokeWidth: 0.571,
    d: "M4.089 16.797l1.807-.081"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#f5f6f7",
    strokeWidth: 0.571,
    d: "M4.082 16.614l1.808-.055"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#f9fafb",
    strokeWidth: 0.571,
    d: "M4.077 16.43l1.809-.028"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.571,
    d: "M4.076 16.247h1.809"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M12.366 11.734l-1.776-.344"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#4d5960",
    strokeWidth: 0.571,
    d: "M12.363 11.761l-1.776-.344"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#525e66",
    strokeWidth: 0.571,
    d: "M12.36 11.788l-1.776-.344"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#57646b",
    strokeWidth: 0.571,
    d: "M12.376 11.656l-1.809-.02"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#5c6971",
    strokeWidth: 0.571,
    d: "M12.37 11.541l-1.789.269"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#616e76",
    strokeWidth: 0.571,
    d: "M12.336 11.396l-1.704.607"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#67737b",
    strokeWidth: 0.571,
    d: "M12.263 11.239l-1.534.96"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#6c7880",
    strokeWidth: 0.571,
    d: "M12.156 11.102l-1.289 1.267"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#707d85",
    strokeWidth: 0.571,
    d: "M12.039 11.001l-1.018 1.495"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#75828a",
    strokeWidth: 0.571,
    d: "M11.935 10.939l-.768 1.638"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#7b878f",
    strokeWidth: 0.571,
    d: "M11.854 10.905l-.558 1.721"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#808c94",
    strokeWidth: 0.571,
    d: "M11.8 10.888l-.399 1.764"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#859299",
    strokeWidth: 0.571,
    d: "M11.77 10.879l-.283 1.788"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#8a979e",
    strokeWidth: 0.571,
    d: "M11.76 10.875l-.203 1.798"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#909ca3",
    strokeWidth: 0.571,
    d: "M11.767 10.874l-.154 1.802"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#95a1a8",
    strokeWidth: 0.571,
    d: "M11.787 10.873l-.13 1.804"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#9ba7ae",
    strokeWidth: 0.571,
    d: "M11.819 10.872l-.128 1.804"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a1acb3",
    strokeWidth: 0.571,
    d: "M11.864 10.873l-.149 1.803"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a7b1b8",
    strokeWidth: 0.571,
    d: "M11.966 10.884l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#acb7bd",
    strokeWidth: 0.571,
    d: "M11.992 10.886l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#b3bcc3",
    strokeWidth: 0.571,
    d: "M12.02 10.888l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#b9c2c8",
    strokeWidth: 0.571,
    d: "M12.046 10.891l-.298 1.783"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#bfc8cd",
    strokeWidth: 0.571,
    d: "M12.072 10.893l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c5cdd3",
    strokeWidth: 0.571,
    d: "M12.099 10.895l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#cbd3d7",
    strokeWidth: 0.571,
    d: "M12.126 10.897l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#d1d8dd",
    strokeWidth: 0.571,
    d: "M12.152 10.899l-.298 1.785"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#d8dee2",
    strokeWidth: 0.571,
    d: "M12.179 10.901l-.298 1.785"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#dee4e7",
    strokeWidth: 0.571,
    d: "M12.206 10.904l-.299 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#e6eaec",
    strokeWidth: 0.571,
    d: "M12.232 10.906l-.297 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#eceff1",
    strokeWidth: 0.571,
    d: "M12.259 10.908l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#f4f6f7",
    strokeWidth: 0.571,
    d: "M12.285 10.91l-.298 1.784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.843 7.213l.072-1.808m-9.603 5.507l-.299 1.784",
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#fbfbfc",
    strokeWidth: 0.571,
    d: "M21.865 7.213l.103-1.806"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#f8f9f9",
    strokeWidth: 0.571,
    d: "M21.863 7.212l.151-1.802"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#f5f6f7",
    strokeWidth: 0.571,
    d: "M21.858 7.211l.188-1.799"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#f3f4f6",
    strokeWidth: 0.571,
    d: "M21.896 7.214l.136-1.803"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#f0f2f4",
    strokeWidth: 0.571,
    d: "M21.952 7.216l.059-1.807"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#edf0f2",
    strokeWidth: 0.571,
    d: "M21.939 7.215l.104-1.805"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#ebeff1",
    strokeWidth: 0.571,
    d: "M21.929 7.214l.144-1.802"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#e9edef",
    strokeWidth: 0.571,
    d: "M21.926 7.213l.175-1.798"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#e7ebed",
    strokeWidth: 0.571,
    d: "M21.926 7.213l.201-1.796"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#e4e9ec",
    strokeWidth: 0.571,
    d: "M21.931 7.213l.223-1.794"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#e2e7ea",
    strokeWidth: 0.571,
    d: "M21.937 7.214l.247-1.79"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#e0e5e8",
    strokeWidth: 0.571,
    d: "M21.944 7.215l.269-1.787"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#dee3e7",
    strokeWidth: 0.571,
    d: "M21.953 7.216l.292-1.784"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#dce2e5",
    strokeWidth: 0.571,
    d: "M21.962 7.217l.315-1.779"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#dae0e3",
    strokeWidth: 0.571,
    d: "M21.972 7.219l.34-1.775"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#d8dee2",
    strokeWidth: 0.571,
    d: "M21.981 7.221l.368-1.769"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#d6dce0",
    strokeWidth: 0.571,
    d: "M21.991 7.223l.396-1.763"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#d4dbdf",
    strokeWidth: 0.571,
    d: "M22 7.225l.427-1.755"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#d2d9dd",
    strokeWidth: 0.571,
    d: "M22.007 7.227l.461-1.747"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#d0d7dc",
    strokeWidth: 0.571,
    d: "M22.013 7.229l.499-1.736"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#ced5da",
    strokeWidth: 0.571,
    d: "M22.018 7.23l.541-1.724"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#ccd4d8",
    strokeWidth: 0.571,
    d: "M22.019 7.231l.585-1.709"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#cad2d7",
    strokeWidth: 0.571,
    d: "M22.018 7.231l.637-1.691"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c8d0d5",
    strokeWidth: 0.571,
    d: "M22.014 7.23l.693-1.669"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c6cfd3",
    strokeWidth: 0.571,
    d: "M22.006 7.227l.755-1.642"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c4cdd2",
    strokeWidth: 0.571,
    d: "M22.026 7.237l.757-1.641"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c3cbd0",
    strokeWidth: 0.571,
    d: "M22.046 7.247l.76-1.639"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c1c9cf",
    strokeWidth: 0.571,
    d: "M22.064 7.256l.765-1.637"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#bec7cd",
    strokeWidth: 0.571,
    d: "M22.082 7.265l.771-1.635"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#bcc6cb",
    strokeWidth: 0.571,
    d: "M22.1 7.274l.775-1.632"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#bbc4ca",
    strokeWidth: 0.571,
    d: "M22.115 7.283l.783-1.629"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#b9c2c8",
    strokeWidth: 0.571,
    d: "M22.13 7.291l.791-1.625"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#b7c1c6",
    strokeWidth: 0.571,
    d: "M22.144 7.298l.8-1.621"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#b5bfc5",
    strokeWidth: 0.571,
    d: "M22.156 7.306l.812-1.616"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#b3bdc3",
    strokeWidth: 0.571,
    d: "M22.168 7.312l.823-1.608"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#b1bbc2",
    strokeWidth: 0.571,
    d: "M22.178 7.319l.838-1.602"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#afb9c0",
    strokeWidth: 0.571,
    d: "M22.187 7.324l.852-1.594"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#adb8be",
    strokeWidth: 0.571,
    d: "M22.193 7.329l.871-1.585"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#acb6bc",
    strokeWidth: 0.571,
    d: "M22.198 7.333l.893-1.574"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#aab4bb",
    strokeWidth: 0.571,
    d: "M22.201 7.336l.914-1.561"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a8b3b9",
    strokeWidth: 0.571,
    d: "M22.203 7.338l.939-1.546"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#8b979f",
    strokeWidth: 0.571,
    d: "M23.378 8.54l1.279-1.279"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#88949c",
    strokeWidth: 0.571,
    d: "M23.682 8.843L24.997 7.6"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#859199",
    strokeWidth: 0.571,
    d: "M23.972 9.15l1.352-1.201"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#818e95",
    strokeWidth: 0.571,
    d: "M24.247 9.462l1.392-1.154"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#7e8a92",
    strokeWidth: 0.571,
    d: "M24.508 9.78l1.432-1.104"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#7b878f",
    strokeWidth: 0.571,
    d: "M24.754 10.104l1.474-1.049"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#78848c",
    strokeWidth: 0.571,
    d: "M24.985 10.435l1.515-.989"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#758189",
    strokeWidth: 0.571,
    d: "M25.201 10.773l1.555-.923"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#717e86",
    strokeWidth: 0.571,
    d: "M25.402 11.121l1.594-.855"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#6e7b83",
    strokeWidth: 0.571,
    d: "M25.588 11.479l1.631-.783"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#6b7880",
    strokeWidth: 0.571,
    d: "M25.758 11.847l1.666-.705"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#68757c",
    strokeWidth: 0.571,
    d: "M25.909 12.216l1.691-.642"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#657179",
    strokeWidth: 0.571,
    d: "M26.048 12.594l1.711-.586"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#616e76",
    strokeWidth: 0.571,
    d: "M26.177 12.982l1.728-.529"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#5e6b73",
    strokeWidth: 0.571,
    d: "M26.294 13.381l1.746-.473"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#5b686f",
    strokeWidth: 0.571,
    d: "M26.399 13.787l1.76-.415"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#58646c",
    strokeWidth: 0.571,
    d: "M26.49 14.198l1.774-.355"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#556169",
    strokeWidth: 0.571,
    d: "M26.567 14.611l1.785-.292"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#515e65",
    strokeWidth: 0.571,
    d: "M26.628 15.025l1.794-.226"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#4e5a62",
    strokeWidth: 0.571,
    d: "M26.673 15.437l1.802-.156"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#4a575e",
    strokeWidth: 0.571,
    d: "M26.7 15.845l1.807-.081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.519 16.246h-1.81m0 0h1.81",
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#46525a",
    strokeWidth: 0.571,
    d: "M28.508 16.728l-1.807-.073"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#465259",
    strokeWidth: 0.571,
    d: "M28.479 17.208l-1.803-.146"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#455158",
    strokeWidth: 0.571,
    d: "M28.431 17.685l-1.796-.218"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#445057",
    strokeWidth: 0.571,
    d: "M28.363 18.157l-1.786-.287"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#434f56",
    strokeWidth: 0.571,
    d: "M28.278 18.626l-1.773-.356M28.175 19.09l-1.759-.423"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#424e55",
    strokeWidth: 0.571,
    d: "M28.055 19.549l-1.743-.489"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#414d54",
    strokeWidth: 0.571,
    d: "M27.917 20.002l-1.723-.553"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#414c53",
    strokeWidth: 0.571,
    d: "M27.763 20.45l-1.701-.617"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#404b53",
    strokeWidth: 0.571,
    d: "M27.593 20.89l-1.677-.678"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3f4b52",
    strokeWidth: 0.571,
    d: "M27.407 21.323l-1.651-.738"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3e4a51",
    strokeWidth: 0.571,
    d: "M27.206 21.749l-1.624-.797"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3e4950",
    strokeWidth: 0.571,
    d: "M26.99 22.167l-1.594-.855"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3d484f",
    strokeWidth: 0.571,
    d: "M26.759 22.576l-1.563-.911"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3c474f",
    strokeWidth: 0.571,
    d: "M26.515 22.977l-1.531-.967"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3b474e",
    strokeWidth: 0.571,
    d: "M26.256 23.367l-1.494-1.019"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3b464d",
    strokeWidth: 0.571,
    d: "M25.983 23.748l-1.457-1.072"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3a454c",
    strokeWidth: 0.571,
    d: "M25.698 24.118l-1.418-1.124"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#39444b",
    strokeWidth: 0.571,
    d: "M25.4 24.477l-1.376-1.174"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#38434a",
    strokeWidth: 0.571,
    d: "M25.09 24.825l-1.333-1.223M24.768 25.161L23.48 23.89m1.288 1.271L23.48 23.89M24.602 25.321l-1.25-1.307"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#38444b",
    strokeWidth: 0.571,
    d: "M24.423 25.485l-1.222-1.332"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#39444b",
    strokeWidth: 0.571,
    d: "M24.233 25.653l-1.2-1.354M24.034 25.822l-1.182-1.368"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3a454c",
    strokeWidth: 0.571,
    d: "M23.828 25.991l-1.166-1.381M23.62 26.159l-1.153-1.394"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3b464d",
    strokeWidth: 0.571,
    d: "M23.411 26.323l-1.14-1.405M23.205 26.48l-1.126-1.413"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3b474e",
    strokeWidth: 0.571,
    d: "M23.004 26.629l-1.111-1.425"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3c474e",
    strokeWidth: 0.571,
    d: "M22.812 26.77l-1.096-1.438"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3c474f",
    strokeWidth: 0.571,
    d: "M22.632 26.897l-1.077-1.454"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a8b3b9",
    strokeWidth: 0.571,
    d: "M22.116 7.496l.929-1.553"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a5b0b7",
    strokeWidth: 0.571,
    d: "M22.251 7.59l.96-1.533"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a2adb4",
    strokeWidth: 0.571,
    d: "M22.377 7.681l.994-1.51"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a0abb2",
    strokeWidth: 0.571,
    d: "M22.495 7.77l1.03-1.486"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#9da9b0",
    strokeWidth: 0.571,
    d: "M22.608 7.857l1.067-1.46"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#9ba6ad",
    strokeWidth: 0.571,
    d: "M22.718 7.944l1.102-1.432"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#98a4ab",
    strokeWidth: 0.571,
    d: "M22.825 8.034l1.137-1.406"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#95a1a8",
    strokeWidth: 0.571,
    d: "M22.931 8.125l1.171-1.378"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#939fa6",
    strokeWidth: 0.571,
    d: "M23.038 8.221L24.24 6.87"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#919ca4",
    strokeWidth: 0.571,
    d: "M23.147 8.32l1.231-1.324"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#8e9aa1",
    strokeWidth: 0.571,
    d: "M23.261 8.427l1.256-1.301"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#8b979f",
    strokeWidth: 0.571,
    d: "M23.378 8.54l1.279-1.279"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#3c474f",
    strokeWidth: 0.571,
    d: "M22.327 26.485l-1.077-1.453"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#455158",
    strokeWidth: 0.571,
    d: "M22.261 26.52l-1.047-1.451"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#4e5a61",
    strokeWidth: 0.571,
    d: "M22.19 26.558l-1.025-1.444"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#56626a",
    strokeWidth: 0.571,
    d: "M22.122 26.594l-1.005-1.437"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#5e6b72",
    strokeWidth: 0.571,
    d: "M22.06 26.625l-.98-1.431"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#66737a",
    strokeWidth: 0.571,
    d: "M21.668 26.778l-.322-1.686"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#6e7b83",
    strokeWidth: 0.571,
    d: "M21.357 26.782l.144-1.692"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#76828a",
    strokeWidth: 0.571,
    d: "M21.135 26.731l.434-1.619"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#7e8a92",
    strokeWidth: 0.571,
    d: "M20.933 26.647l.714-1.498"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#86929a",
    strokeWidth: 0.571,
    d: "M20.675 26.454l1.158-1.162"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#8f9ba2",
    strokeWidth: 0.571,
    d: "M20.579 26.329l1.285-.991"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#97a3aa",
    strokeWidth: 0.571,
    d: "M20.509 26.209l1.362-.845"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a0abb2",
    strokeWidth: 0.571,
    d: "M20.455 26.092l1.411-.72"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a9b4ba",
    strokeWidth: 0.571,
    d: "M20.413 25.975l1.441-.609"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#b3bdc3",
    strokeWidth: 0.571,
    d: "M20.379 25.858l1.462-.507"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#bcc5cb",
    strokeWidth: 0.571,
    d: "M20.353 25.738l1.473-.407"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c6ced3",
    strokeWidth: 0.571,
    d: "M20.334 25.615l1.479-.308"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#d0d7db",
    strokeWidth: 0.571,
    d: "M20.323 25.487l1.477-.203"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#dae0e3",
    strokeWidth: 0.571,
    d: "M20.321 25.356l1.47-.092"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#e4e9ec",
    strokeWidth: 0.571,
    d: "M20.328 25.26l1.453-.043"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#f0f2f4",
    strokeWidth: 0.571,
    d: "M20.337 25.196l1.434-.045"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.571,
    d: "M20.346 25.129l1.416-.045"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M11.542 6.336l-1.093.257"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#4f5c63",
    strokeWidth: 0.571,
    d: "M11.534 6.314l-1.092.28"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#57636b",
    strokeWidth: 0.571,
    d: "M11.525 6.293l-1.089.301"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#5e6b73",
    strokeWidth: 0.571,
    d: "M11.518 6.272l-1.088.322"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#66737a",
    strokeWidth: 0.571,
    d: "M11.51 6.251l-1.087.345"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#6d7a82",
    strokeWidth: 0.571,
    d: "M11.502 6.23l-1.085.365"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#758289",
    strokeWidth: 0.571,
    d: "M11.493 6.209l-1.084.387"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#7c8991",
    strokeWidth: 0.571,
    d: "M11.485 6.188l-1.082.408"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#849198",
    strokeWidth: 0.571,
    d: "M11.478 6.167l-1.082.43"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#8c98a0",
    strokeWidth: 0.571,
    d: "M11.47 6.146l-1.079.452"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#94a0a7",
    strokeWidth: 0.571,
    d: "M11.461 6.125l-1.077.473"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#9ca8af",
    strokeWidth: 0.571,
    d: "M11.453 6.104l-1.076.495"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a5b0b7",
    strokeWidth: 0.571,
    d: "M11.445 6.083l-1.074.516"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#aeb8be",
    strokeWidth: 0.571,
    d: "M11.437 6.062l-1.073.538"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#b7c0c6",
    strokeWidth: 0.571,
    d: "M11.429 6.04l-1.072.561"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c0c8ce",
    strokeWidth: 0.571,
    d: "M11.421 6.02l-1.069.581"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c9d1d5",
    strokeWidth: 0.571,
    d: "M11.413 5.998l-1.068.603"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#d2d9dd",
    strokeWidth: 0.571,
    d: "M11.404 5.977l-1.065.625"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#dce1e5",
    strokeWidth: 0.571,
    d: "M11.396 5.956l-1.065.646"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#e6eaed",
    strokeWidth: 0.571,
    d: "M11.389 5.935l-1.064.668"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#f0f3f4",
    strokeWidth: 0.571,
    d: "M11.38 5.914l-1.061.689"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.571,
    d: "M11.372 5.893l-1.06.711"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.712,
    d: "M21.069 21.443l.018 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#47535b",
    strokeWidth: 0.571,
    d: "M21.087 20.37l-.323 1.15"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#525e66",
    strokeWidth: 0.571,
    d: "M21.11 20.368l-.272 1.154"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#5c6870",
    strokeWidth: 0.571,
    d: "M21.157 20.372l-.265 1.148"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#65727a",
    strokeWidth: 0.571,
    d: "M21.214 20.38l-.289 1.135"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#6f7c84",
    strokeWidth: 0.571,
    d: "M21.287 20.398l-.358 1.11"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#79868e",
    strokeWidth: 0.571,
    d: "M21.383 20.433L20.9 21.49"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#839097",
    strokeWidth: 0.571,
    d: "M21.498 20.497l-.655.955"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#8e9aa1",
    strokeWidth: 0.571,
    d: "M21.614 20.595l-.841.795"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#98a4ab",
    strokeWidth: 0.571,
    d: "M21.707 20.714l-.986.605"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#a3aeb5",
    strokeWidth: 0.571,
    d: "M21.765 20.831l-1.072.436"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#afb9bf",
    strokeWidth: 0.571,
    d: "M21.799 20.932l-1.116.314"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#bbc4ca",
    strokeWidth: 0.571,
    d: "M21.817 21.018l-1.136.24"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#c6cfd4",
    strokeWidth: 0.571,
    d: "M21.828 21.098l-1.148.199"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#d3dade",
    strokeWidth: 0.571,
    d: "M21.834 21.175l-1.156.185"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#dfe4e8",
    strokeWidth: 0.571,
    d: "M21.835 21.212l-1.158.213"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#edf0f2",
    strokeWidth: 0.571,
    d: "M21.835 21.237l-1.158.25"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.571,
    d: "M21.835 21.262l-1.158.287"
  }))), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M64.987 20.719c0 3.5-3.227 5.803-6.485 5.803H47.878V5.738h9.741c3.745 0 6.454 1.872 6.454 5.71 0 3.285-2.861 4.267-2.861 4.267 0 .031 3.775.891 3.775 5.004m-6.211-8.687c0-1.167-.791-1.966-1.979-1.966h-3.806v3.869h3.714c1.341 0 2.071-.982 2.071-1.903m.67 8.104c0-1.197-.883-2.026-2.74-2.026h-3.714v4.083h3.806c1.553 0 2.648-.552 2.648-2.057M86.005 16.114c0 6.109-3.502 10.898-9.559 10.898-6.028 0-9.56-4.789-9.56-10.898 0-6.079 3.531-10.899 9.559-10.899 6.058 0 9.56 4.821 9.56 10.899m-5.115 0c0-3.255-1.49-5.895-4.443-5.895s-4.414 2.64-4.414 5.895c0 3.285 1.461 5.925 4.414 5.925s4.443-2.64 4.443-5.925M103.856 20.228c0 4.574-4.14 6.785-8.036 6.785-4.506 0-6.819-1.72-8.645-3.899l3.317-3.255c1.4 1.782 3.228 2.672 5.267 2.672 1.674 0 2.8-.829 2.8-2.058 0-1.319-.995-1.73-3.714-2.302l-.73-.153c-3.275-.688-5.967-2.548-5.967-6.263 0-4.084 3.318-6.54 7.701-6.54 3.715 0 6.119 1.597 7.581 3.255l-3.228 3.193c-1.005-1.075-2.526-1.935-4.262-1.935-1.187 0-2.526.553-2.526 1.935 0 1.258 1.395 1.715 3.165 2.088l.731.153c2.965.622 6.546 1.535 6.546 6.324M123.626 22.5c-2.13 3.07-4.108 4.513-8.218 4.513-5.846 0-9.621-4.851-9.621-11.022 0-5.863 3.41-10.745 9.681-10.745 3.439 0 5.905 1.351 8.008 4.514l-4.202 2.793c-.853-1.474-1.948-2.333-3.775-2.333-2.312 0-4.536 2.068-4.536 5.771 0 4.151 2.406 6.048 4.689 6.048 1.978 0 2.891-.982 3.744-2.394l4.23 2.855M143.122 26.522h-5.479v-8.197h-6.301v8.197h-5.449V5.738h5.449v7.644h6.301V5.738h5.479z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ed1d24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBosch);
export default __webpack_public_path__ + "static/media/bosch.3c2e5ac45f76f1a0f3b0dcceb38afe63.svg";
export { ForwardRef as ReactComponent };